var app = app || {};

/**
 * Public facing custom enrollment module
 */
app.enroll = (function() {
    'use strict';
    var cookieName = 'myyl_enrollment',
        templateLoaded = false,
        firstLoad = true,
        currentStep = false,
        keys = ['kits', 'products', 'monthly'],
        pageData = {
            kits: [],
            products: [],
            monthly: [],
            partnerType: ''
        },

        // this is used to generate the country select dropdown in the first step
        countries = null,
        categories = [],
        products = [],
        // bundles = [],
        kits = [],
        productList = [],
        welcomeData = null,

        // country specific options - may be overridden by setDefaults()
        totalPV = 0,
        minPV = 50,
        // used only with ceo and if a kit is deselected
        minPVceo = 100,
        discount = 0.24,
        pvProducts = 0,

        // determines the interval of a subscription partner
        subscriptionInterval = 'monthly',

        // are kits required or optional to sign up?
        kitsOptional = false,

        // should selected kits be added to products or monthly er? will also include in PV total
        kitsMonthly = false,

        // special case for CEO whe kits are optional but initially selected, need to keep track
        // of a deliberate deselect to it won't get re-selected later
        kitDeselected = false,

        // canada
        canadaCE = false,

        // currently for jp only
        gaiyoshomenRequired = false,

        // special product guide, canada only
        productGuideID = 33548,

        // currently for au/nz only
        ceoEnabled = false,

        // special product id for CEO packages
        ceoItemID = 34473,

        // hide step nave for certain regions
        stepNavEnabled = false,

        // some regions (au) require a gateway step to choose normal products vs. monthly er
        gatewayPage = false,

        // some regions don't allow monthly er at all, or it's an option chosen from the gateway page
        // for regions that start with gatewayPage, this decides whether they get standard products or monthly CE
        // 2022-12-20 If required this can be leveraged to disable subscriptions in the ewm flow
        monthlyEnabled = true,

        // package name from url eg. build/subscribe/package-slug-name
        requestedSlug = '',

        enrollmentPackage = {
            product_ids: {
                kits: [],
                products: [],
                monthly: []
            },
            welcome: 0
        },

        enrollmentSelected = {
            kits: [],
            products: [],
            monthly: [],
            e2: {},
            partnerType: 'subscription'
        },

        alreadySelected = false,

        steps = {
            products: true, // always true
            monthly: false,
            review: false
        },

        monthlySeen = false,
        monthlyConfirmed = false,

        // if an enrollment package was loaded from link builder, save it here
        customPackage = null,
        carousel = null,
        customLanguageLoaded = false,

        // reserved slugs for global default and international bundles
        reservedSlugs = ['default', 'international'],

        // search field in 'add additional' bundle products section
        // searchData = null,
        // searchTotal = 0,

        refreshCart = false,
        refreshCount = 0,

        self = {

        loadsAsyncronously: true,

        init: function(step, slug) {
            app.page.showLoader();

            if (slug) {
                // global default package
                if (slug === 'default') {
                    enrollmentPackage = self.getDefaultPackage();
                    self.saveState();
                    slug = '';
                }

                slug = decodeURIComponent(slug);
                self.addShareParam(slug);

            } else {

                var share = app.main.getShareParam();

                if (share && !self.setRequestedSlug(share)) {
                    // setRequestedSlug() reloaded, cancel init
                    return;
                }

                // no slug and skava enabled, use global default
                if (app.main.getSettings().skavaEnabled) {
                    enrollmentPackage = self.getDefaultPackage();
                }
            }

            if (app.pws.isPreview()) {
                $('body').addClass('preview');
                app.cookie.clear(cookieName);
            }

            // check to see if slug was previously saved
            if (!slug && app.cookie.get(cookieName)) {
                enrollmentSelected = JSON.parse(app.cookie.get(cookieName));

                // console.log(enrollmentSelected.partnerType);

                if (enrollmentSelected.slug) {
                    enrollmentSelected.slug = decodeURIComponent(enrollmentSelected.slug);
                    slug = enrollmentSelected.slug;
                    firstLoad = false;
                }
            }

            if (slug && customLanguageLoaded == false && reservedSlugs.includes(slug) == false) {
                customLanguageLoaded = true;

                var packageType = app.main.getSettings().skavaEnabled ? 'package' : 'enrollment';
                $.getJSON(assetURL[mode] + packageType +'/'+ app.main.getProfile().member_id +'/'+ slug +'.json')
                    .done(function(pkg) {
                        if (pkg.language) {
                            if (pkg.language != app.main.getCurrentCulture()) {
                                var cookie = app.cookie.get(),
                                    cookieData = {};

                                if (cookie) {
                                    cookieData = JSON.parse(cookie);
                                }

                                cookieData.country = pkg.location;
                                cookieData.culture = pkg.language;
                                app.cookie.set(JSON.stringify(cookieData));

                                app.main.loadLanguageData(pkg.language);
                                return;

                            } else {
                                self.initProducts(step, slug);
                            }

                        } else {
                            self.initProducts(step, slug);
                        }
                    })

                    .fail(function(error) {
                        // fallback to standard enrollment
                        console.log('failed to load custom link');
                        self.reset();

                        if (app.main.getSettings().skavaEnabled) {
                            console.log('get featured package');
                            enrollmentPackage = self.getFeaturedPackage();

                            if (enrollmentPackage == false) {
                                console.log('get global default package');
                                enrollmentPackage = self.getDefaultPackage();
                            }

                            self.saveState();

                            // app.page.loadPage('build/subscription', true);
                            window.location.hash = 'bwm/'+ enrollmentPackage.slug;
                            return;

                        } else {
                            app.page.loadPage('build', true);
                        }

                        return;
                    });

            } else {
                self.initProducts(step, slug);
            }
        },

        // used by the language chooser to clear products so they'll be reloaded for the chosen culture
        clearProducts: function() {
            products = [];
        },

        // first load products before anything else
        initProducts: function(step, slug) {
            if (slug) {
                slug = decodeURIComponent(slug);
            }

            if (products.length) {
                // products already loaded. next step...
                if (app.main.checkInStock(products) === true) {
                    self.initPackage(step, slug);
                }

            } else {

                // now that we're using product_ids, products must be loaded first to be able to translate to item_ids for selected products
                // load the full products list

                if (app.main.getSettings().skavaEnabled) {
                    $.getJSON(assetURL[mode] +'json/'+ app.main.getCurrentCulture() +'/'+ app.main.getCountryCode() +'/products-v2.json'+ cb)
                        .done(function(data) {
                            products = data;
                            // include oos items, let the template hide them
                            app.products.groupVariants(products, true);
                            app.products.setSubscribed(products, 'enroll');
                            self.initPackage(step, slug);
                        });

                } else {
                    // legacy
                    var productsURL = assetURL[mode] +'json/'+ app.main.getCurrentCulture() +'/'+ app.main.getCountryCode() +'/products.json'+ cb;

                    // dev and test product data needs to match prod for testing
                    if (app.main.getCountryCode() == 'au' && ['local', 'dev'].includes(mode)) {
                        console.log('using local products.json');
                        productsURL = 'json/en-au/products.json';
                    }

                    $.getJSON(productsURL)
                    // $.getJSON('json/products.json')
                        .done(function(data) {
                            if (app.main.checkInStock(data) === true) {
                                products = data;

                                // include oos items, let the template hide them
                                app.products.groupVariants(products, true);
                                self.initPackage(step, slug);
                            }

                            // special case for australia
                            app.products.parseAuProducts('enroll');
                        })

                        .fail(function() {
                            app.message.error('Unable to load products.');
                        });
                }
            }
        },

        // return loaded products for use in product search
        getProducts: function() {
            return products;
        },

        // used only for additional products search in bundles flow
        loadCategories: function(callback) {
            var file = app.main.getSettings().skavaEnabled ? 'categories-v2.json' : 'categories.json';
            var url = assetURL[mode] +'json/'+ app.main.getCurrentCulture() +'/'+ file + cb;

            // dev and test category data needs to match prod for testing
            if (app.main.getCountryCode() == 'au' && ['local', 'dev'].includes(mode)) {
                console.log('using local categories.json');
                url = 'json/en-au/categories.json';
            }

            $.getJSON(url)
                .done(function(data) {
                    categories = data;
                    app.main.sort(categories, 'name');
                    callback();

                }).fail(function(a, b, c) {
                    // todo: error handling
                });
        },

        // returns false if bwm package needs to be loaded
        setRequestedSlug: function(name) {
            // for international bundle, do nothing here
            if (name) {
                if (name.indexOf('international') > -1) {
                    return true;
                }
            }

            if (app.cookie.get(cookieName)) {
                enrollmentSelected = JSON.parse(app.cookie.get(cookieName));
            }

            if (name && name != 'default') {
                requestedSlug = decodeURIComponent(name);

            } else {
                requestedSlug = '';
            }

            // console.log('requestedSlug is '+ requestedSlug);
            // console.log('slug in memory is '+ decodeURIComponent(enrollmentSelected.slug));

            if (requestedSlug && enrollmentSelected.slug) {
                if (requestedSlug == decodeURIComponent(enrollmentSelected.slug)) {
                    // do nothing
                    // console.log('requestedSlug '+ requestedSlug +' already loaded.');
                    return true;

                } else {
                    // both exist but don't match, so load requestedSlug
                    app.page.loadPage('bwm/'+ requestedSlug, true);
                }
            }

            if (requestedSlug && !enrollmentSelected.slug) {
                app.page.loadPage('bwm/'+ requestedSlug, true);
                return false;
            }
        },

        /**
         * add the share param to the url so bundle meta data can be injected
         */
        addShareParam: function(slug) {
            var params = new URLSearchParams(window.location.search);
            params.set('share', slug);
            window.location.search = params;
        },

        /**
         * Initialize the chosen international bundle
         */
        setIntlBundle: function(codes) {
            // todo: check if codes are valid
            self.reset();
            products = [];
            enrollmentPackage = self.getDefaultPackage(codes.culture);
            self.saveState();
        },

        /**
         * Appends package slug to requested url
         */
        getPath: function(page) {
            if (app.main.getSettings().skavaEnabled) {
                return page + (requestedSlug ? '/'+ requestedSlug : '');

            } else {
                return page;
            }
        },

        // slug = link builder slug
        initPackage: function(step, slug) {
            if (step == 'review' && categories.length < 1) {
                // load categories for additional products search
                self.loadCategories(function() {
                    self.initPackage(step, slug);
                });

                return;
            }

            // always reset if hash contains ewm or bwm
            var pieces = app.main.getHash().split('/');
            if (['ewm', 'bwm'].includes(pieces[0])) {
                // console.log('resetting because of ewm/bwm');
                self.reset();

                if (app.main.getSettings().skavaEnabled) {
                    app.skava.deleteCart();
                }
            }

            if (slug) {
                slug = decodeURIComponent(slug);
            }

            // check to see if slug was previously saved
            if (!slug && app.cookie.get(cookieName)) {
                enrollmentSelected = JSON.parse(app.cookie.get(cookieName));

                if (enrollmentSelected.slug) {
                    enrollmentSelected.slug = decodeURIComponent(enrollmentSelected.slug);
                    slug = enrollmentSelected.slug;
                    firstLoad = false;
                }
            }

            if (slug) {
                // custom link json is still in memory
                if (customPackage && (slug == customPackage.slug)) {
                    // console.log('custom package '+ customPackage.slug +' is in memory');
                    enrollmentPackage = customPackage;

                    self.populatePackage(step);

                } else {
                    // only load the external link builder json on first page load
                    var packageType = app.main.getSettings().skavaEnabled ? 'package' : 'enrollment';

                    $.getJSON(assetURL[mode] + packageType +'/'+ app.main.getProfile().member_id +'/'+ slug +'.json')
                        .done(function(data) {
                            // console.log('custom package '+ data.slug +' loaded');
                            if (firstLoad) {
                                firstLoad = false;

                                // on first page load, clear any previously saved package data, select all products and save, then redirect to checkout view
                                self.reset();
                                customPackage = data;
                                enrollmentPackage = data;

                                // for selected products, we're still using item_id as that is ultimately what needs to be sent VO
                                enrollmentSelected.slug = decodeURIComponent(data.slug);
                                self.selectAllProducts();
                                self.saveState();

                                // only track this as a view when not in preview mode
                                if (!app.pws.isPreview()) {
                                    app.main.track('EwM-'+ app.main.getProfile().member_id, 'view', slug);
                                }

                                var redirectPage = 'build';
                                if (app.main.getSettings().skavaEnabled) {
                                    redirectPage = self.getPath('build/subscription');
                                }

                                app.page.loadPage(redirectPage, true);
                                return;

                            } else {
                                // console.log('no redirect because of firstload');
                                enrollmentPackage = data;
                                customPackage = data;
                                self.populatePackage(step);
                            }
                        })

                        .fail(function(error) {
                            // fallback to standard enrollment
                            refreshCount++;
                            console.log(refreshCount +' failed to load custom link');

                            if (refreshCount < 2) {
                                self.reset();

                                var buildPage = 'build';

                                if (app.main.getSettings().skavaEnabled) {
                                    buildPage = 'build/subscription';
                                }

                                app.page.loadPage(buildPage, true);
                                return;

                            } else {
                                console.log('too many refreshes');
                                app.page.loadPage('');
                                return;
                            }
                        });
                }

            } else {
                // abort if custom enrollment isn't active
                if (app.main.checkCustomEnrollmentEnabled() == false) {
                    app.page.loadPage('');
                    return;
                }

                // // if requestedSlug is set, then it's in the url and may need to be loaded
                // if (requestedSlug) {
                //     console.log(enrollmentSelected.slug, requestedSlug);

                //     if (enrollmentSelected.slug != requestedSlug) {
                //         console.log('--- need to load '+ requestedSlug +'?');
                //         app.page.loadPage('bwm/'+ requestedSlug, true);
                //         return;

                //     } else {
                //         console.log('requestedSlug '+ requestedSlug +' already loaded.');
                //     }
                // }

                // for international bundles, it's already been loaded so skip this
                if (slug != 'international') {
                    if (app.main.getSettings().skavaEnabled) {
                        // first check if primary package is available

                        // use primary package if found
                        if (self.getFeaturedPackage()) {
                            enrollmentPackage = self.getFeaturedPackage();
                            console.log('using featured package');

                        } else {
                            // fallback to defaultPackage
                            enrollmentPackage = self.getDefaultPackage();
                        }

                    } else {
                        // original method, try member's default first
                        try {
                            enrollmentPackage = app.main.getProfile().custom_enrollment.config;

                        } catch(err) {
                            enrollmentPackage = self.getDefaultPackage();
                        }
                    }
                }

                // track the view, but not on the welcome page
                if (firstLoad && step != 'welcome') {
                    app.main.track('EwM-'+ app.main.getProfile().member_id, 'view', 'default');
                }

                self.populatePackage(step);
            }
        },

        /**
         * Used as a fallback when all other user packages don't exist or aren't available
         */
        getDefaultPackage: function(cultureCode) {
            // default to global, then look for a local override
            var defKits = app.main.getSettings().global_bundle_kits;
            if (app.main.getSettings().default_kit_product_ids) {
                defKits = app.main.getSettings().default_kit_product_ids;
                console.log('using default_kit_product_ids: '+ defKits);
            }

            var defProducts = app.main.getSettings().global_bundle_products;
            if (app.main.getSettings().default_individual_product_ids) {
                defProducts = app.main.getSettings().default_individual_product_ids;
                console.log('using default_individual_product_ids: '+ defProducts);
            }

            var defMonthly = app.main.getSettings().global_bundle_subscriptions;
            if (app.main.getSettings().default_loyalty_product_ids) {
                defMonthly = app.main.getSettings().default_loyalty_product_ids;
                console.log('using default_loyalty_product_ids: '+ defMonthly);
            }

            var defaultPackage = {
                product_ids: {
                    kits: defKits.split(',').map(Number),
                    products: defProducts.split(',').map(Number),
                    monthly: defMonthly.split(',').map(Number)
                },
                name: app.main.lang('ce_default_package_name'),
                slug: 'default',
                default: false,
                version: 2
            };

            if (cultureCode) {
                console.log('load international package for '+ cultureCode);
                defaultPackage.language = cultureCode;
                defaultPackage.slug = 'international';
                defaultPackage.name = app.main.lang('intl_bundle_title');
            }

            return defaultPackage;
        },

        /**
         * Return the member's featured package if available
         **/
        getFeaturedPackage: function() {
            var targetedPackages = app.main.getProfile().targeted_packages;

            if (targetedPackages) {
                for (var i=0; i<targetedPackages.length; i++) {
                    var pkg = targetedPackages[i].config;

                    if (pkg.rank_id) {
                        if (pkg.rank_id == 1) {
                            return pkg;
                        }
                    }
                }
            }

            return false;
        },

        populatePackage: function(step) {
            var productsOnSale = 0;

            // if unified shopping is enabled, combine monthly with reg products and remove message
            if (app.main.getSettings().unified_shopping_enabled) {
                if (enrollmentPackage.product_ids.monthly.length > 0) {
                    enrollmentPackage.product_ids.products = enrollmentPackage.product_ids.products.concat(enrollmentPackage.product_ids.monthly);
                    enrollmentPackage.product_ids.monthly = [];
                }
            }

            // special case if all monthly products are DSKU then none will appear, so skip the monthly page
            enrollmentPackage.product_ids.monthly.forEach(function(product_id) {
                var product = self.getProductByID(product_id, 'product_id');

                if (product) {
                    if (app.products.isOnSale(product)) {
                        productsOnSale++;
                    }
                }
            });

            if (productsOnSale > 0 && (productsOnSale == enrollmentPackage.product_ids.monthly.length)) {
                // remove all monthly products so that step will be skipped
                enrollmentPackage.product_ids.monthly = [];
                console.log('All monthly ER products are on sale. Skipping monthly step.');
            }

            // if valid cookie exists, set data here
            try {
                if (app.cookie.get(cookieName)) {
                    enrollmentSelected = JSON.parse(app.cookie.get(cookieName));

                    try {
                        if (enrollmentSelected.memberID != app.main.getProfile().member_id) {
                            // member id doesn't match current profile, so cookie is left over from another
                            // session and should be cleared
                            self.reset();
                        }
                    } catch(e) {
                        // if all else fails, clear the cookie and start over
                        self.reset();
                    }

                } else {
                    // use this to auto-select all products, disabled
                    // self.selectAllProducts()
                }
            } catch(e) {
                // clear cookie in case it's invalid
                self.reset();
            }

            if (app.main.getSettings().skavaEnabled) {
                // any bundles in the loyalty(monthly) section that are also in the kits section should be removed
                var product_ids = enrollmentPackage.product_ids;

                if (product_ids.kits.length && product_ids.monthly.length) {
                    var i = product_ids.monthly.length;

                    while (i--) {
                        if (self.getProductIndex(product_ids.monthly[i], product_ids.kits) > -1) {
                            console.log('hiding loyalty kit '+ i);
                            product_ids.monthly.splice(i, 1);
                            continue;
                        }
                    }
                }

                // check for bundle description and load markdown viewer to potentially format it
                if (enrollmentPackage.description) {
                    $.getScript('https://unpkg.com/showdown/dist/showdown.min.js')
                        .done(function(e) {
                            // console.log('loaded showdown');
                        })

                        .fail(function(error) {
                            // console.log('showdown failed to load');
                        });
                }
            }

            self.setDefaults();

            if ([
                'start',
                'gateway',
                'products',
                'brand',
                'monthly',
                'e2',
                'subscription',
                'info',
                'review',
                'review-checkout',
                'membership',
                'welcome',
                'checkout'
                // 'additional'
            ].includes(step)) {
                if (step == 'start') {
                    currentStep = gatewayPage ? 'gateway' : 'products';

                } else {
                    currentStep = step;
                }

            } else {
                // invalid step, default to the first step
                if (app.main.getSettings().skavaEnabled == true) {
                    app.page.loadPage('build/subscription', true);

                } else {
                    app.page.loadPage('build', true);
                }

                return false;
            }

            // no one gets the gateway page unless the region allows it
            if (!gatewayPage && currentStep == 'gateway') {
                //app.page.loadPage('build/products');
                app.page.loadPage('build', true);
                return false;
            }

            self.loadTemplate();
        },

        isCustomPackage: function() {
            if (app.cookie.get(cookieName)) {
                return JSON.parse(app.cookie.get(cookieName)).slug ? true : false;
            }

            return false;
        },

        /**
         * Track er package
         */
        trackEnrollmentPackage: function() {
            var tag = 'EwM-'+ app.main.getProfile().member_id;

            if (enrollmentPackage.slug) {
                app.main.track(tag, 'enroll', enrollmentPackage.slug);

            } else {
                // default
                app.main.track(tag, 'enroll', 'default');
            }

            if (app.skava.getCustomerId()) {
                // same tracking as in app.callback-enroll.js
                app.main.track('enroll-'+ app.skava.getCustomerId(), app.main.getProfile().member_id +'|'+ app.main.getProfile().member_id);
            }
        },

        /**
         * Clear cookie and reset
         * saveCookie - when true, cookie will not be cleared. if a targeted enrollment link was loaded, we don't want to clear it
         */
        reset: function(saveCookie) {
            firstLoad = true;
            alreadySelected = false;
            customPackage = null;
            enrollmentPackage = {
                product_ids: {
                    kits: [],
                    products: [],
                    monthly: [],
                    // bundles: []
                },
                welcome: 0
            };

            enrollmentSelected.kits = [];
            enrollmentSelected.products = [];
            enrollmentSelected.monthly = [];
            enrollmentSelected.e2 = {};
            delete enrollmentSelected.slug;

            requestedSlug = '';

            if (saveCookie !== true) {
                app.cookie.clear(cookieName);

            } else {
                // save the now empty selected items
                self.saveState();
            }
        },

        /**
         * Set any default values based on country
         */
        setDefaults: function() {
            // todo: au no longer uses the gateway page, so any related code for that can
            // be removed at a later date. can probably also remove stepNavEnabled
            // 2019-11-19

            // reset any previously set values in case of a region change
            minPV = 50;
            kitsOptional = false;
            kitsMonthly = false;
            canadaCE = false;
            stepNavEnabled = false;
            gatewayPage = false; // app.main.getSettings().skavaEnabled ? true : false;
            gaiyoshomenRequired = false;
            ceoEnabled = false;

            switch (app.main.getCountryCode()) {
                case 'ca':
                    kitsOptional = true;
                    kitsMonthly = enrollmentSelected.er_optin ? true : false;
                    canadaCE = true;
                break;

                case 'ec':
                case 'mx':
                case 'my':
                case 'sg':
                    minPV = 100;
                break;

                case 'au':
                case 'nz':
                    minPV = 50;
                    ceoEnabled = true;
                    kitsOptional = true;

                    // if no subscription products are available then kit can't be optional
                    if (enrollmentPackage.product_ids.monthly.length < 1) {
                        kitsOptional = false;
                    }

                    // if (ceoEnabled && !enrollmentSelected.kits.length) {
                    //     if (monthlyConfirmed) {
                    //         minPV = 100;
                    //     }
                    // }
                break;

                case 'jp':
                    gaiyoshomenRequired = true;
                break;

                case 'at':
                case 'be':
                case 'cy':
                case 'cz':
                case 'de':
                case 'dk':
                case 'ee':
                case 'es':
                case 'eu':
                case 'fi':
                case 'fr':
                case 'gb':
                case 'gr':
                case 'hr':
                case 'ie':
                case 'it':
                case 'lt':
                case 'lu':
                case 'mt':
                case 'nl':
                case 'pl':
                case 'pt':
                case 'ro':
                case 'ru':
                case 'se':
                case 'sk':
                case 'sl':
                case 'us':
                    kitsOptional = true;
                    minPV = 0;
                break;
            }

            if (app.main.getSettings().unified_shopping_enabled) {
                monthlyEnabled = false;
            }
        },

        // at the moment for AU (ceoEnabled) only
        checkMinPV: function() {
            // if (ceoEnabled) {
            //     // set minPV depending on whether a kit was selected
            //     if (enrollmentSelected.kits.length > 0) {
            //         // they decided on 100 then back to 50
            //         minPV = 50;

            //     } else {
            //         minPV = 100;
            //     }
            // }
        },

        loadTemplate: function() {
            // load the external template
            if (templateLoaded === false) {
                app.main.getTemplate('page-enroll', {}, true, self.ready);

            } else {
                self.ready();
            }
        },

        ready: function() {
            // if e2 isn't active, don't allow that view
            if (currentStep == 'e2') {
                if (!app.main.getSettings().v2_enrollment_enabled) {
                    self.reset();
                    app.page.loadPage('build/monthly', true);
                    return;
                }
            }

            // if e2 is active, use the e2 view
            if (currentStep == 'monthly' && app.main.getSettings().v2_enrollment_enabled) {
                self.reset();
                app.page.loadPage('build/e2');
                return;
            }

            if (templateLoaded === false) {
                var partials = [
                    'steps',
                    'profile',
                    'product',
                    'location-toggle',
                    'subscription-interval',
                    'kits',
                    'bundles',
                    'product-list',
                    'totals',
                    'package-welcome'
                ];

                partials.forEach(function(partial) {
                    Handlebars.registerPartial('enrollment-'+ partial, $('#template-partial-enrollment-'+ partial).html());
                });

                Handlebars.registerHelper('sprintf', function(str) {
                    var vals = [];
                    // Skip the first and last arguments
                    for (var i=1; i<arguments.length-1; ++i) {
                        vals.push(arguments[i]);
                    }
                    return app.main.strReplace(str, vals);
                });

                // when rendering the select drop-down in the template, check which variant has been added, if any
                // variant_id: the product_id for that variant
                Handlebars.registerHelper('variantSelected', function(variant_id, isKit) {
                    if (self.findVariant(variant_id, isKit === true)) {
                        return ' selected';
                    }
                });

                Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
                    return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
                });

                Handlebars.registerHelper('markdown', function(str) {
                    if (showdown) {
                        var converter = new showdown.Converter();
                        var html = converter.makeHtml(str);
                        return new Handlebars.SafeString(html);
                 
                    } else {
                        // default nl2br
                        str = Handlebars.Utils.escapeExpression(str);
                        str = str.replace(/(\r\n|\n|\r)/gm, '<br>');
                        return new Handlebars.SafeString(str);
                    }
                });

                templateLoaded = true;

                app.productcard.init();

                if (!app.main.getSettings().skavaEnabled) {
                    // add iframe for referralId localStorage check
                    if (['dev', 'test', 'live'].includes(mode)) {
                        var query = '?ismyyl=true';
                        var page = ylURL[mode] +'myyl/';

                        app.global.loadIframe(page + query, 'yl-iframe-ismyyl');
                    }
                }
            }

            app.page.postLoad({
                page: 'enrollment',
                title: app.main.lang('label_ce')
            }, self);
        },

        handleNextPrevEvents: function () {
            // handle back / next events
            $('#page-enrollment [data-page]').on('click', function(e) {
                e.preventDefault();
            });
        },

        render: function(data, loadedCb) {
            app.location.applyRebrand();

            if (app.main.getSettings().skavaEnabled) {
                var isFinalStep = currentStep === 'info';

                // do this first to assign quantities
                self.setProductQuantities();

                self.syncBWMCart(function () {
                    self.finishRender(data);
                    self.handleNextPrevEvents();
                    app.page.hideLoader();
                    loadedCb();
                },

                function(err1, err2, err3) {
                    // finish render but don't hide the overlay so the user can see the error
                    // app.skava.handleError(err1, err2, err3);
                    self.finishRender(data);
                    app.page.hideLoader();
                    loadedCb();
                }, isFinalStep);

            } else {
                self.finishRender(data);
                loadedCb();
                app.page.hideLoader();
            }

        },

        unhandledSkavaError: function(jqXHR, textStatus, errorThrown) {
            var response = null;

            try {
                response = JSON.parse(jqXHR.responseText);

            } catch (err) {}

            if (currentStep === 'info' && response && response.code === 'EOCACG0001') {
                // cart timed out
                setTimeout(function() {
                    currentStep = false;
                    self.reset();
                    app.page.loadPage('build', true);
                    window.location.reload();
                }, 1000);
            }
        },

        setProductQuantities: function() {
            var i, k, search;

            for (k=0; k<keys.length; k++) {
                for (i=0; i<enrollmentSelected[keys[k]].length; i++) {
                    search = self.getProductByID(enrollmentSelected[keys[k]][i], 'item_id');

                    // check for quantity and attach
                    if (enrollmentSelected[keys[k]][i].quantity) {
                        search.quantity = enrollmentSelected[keys[k]][i].quantity;
                        // console.log('setting another quantity to', search.quantity);

                    } else {
                        // just in case attempt to delete any previously attached quantity
                        delete search.quantity;
                    }
                }
            }
        },

        finishRender: function(data) {
            var productPage = false,
                i, j, k, search, kit;

            pageData = {
                kits: [],
                products: [],
                monthly: [],
                partnerType: enrollmentSelected.partnerType
            };

            pageData.lang = app.main.getLanguageData();
            pageData.lang.ce_monthly_pv_disclaimer = app.main.strReplace(app.main.lang('ce_monthly_pv_disclaimer'), minPV);
            pageData.lang.ce_not_finding_products = app.main.strReplace(app.main.lang('ce_not_finding_products'), app.main.getEnrollURL());

            // need to override several lang keys for CEO
            if (ceoEnabled) {
                pageData.lang.ce_confirm_monthly_checkbox = app.main.lang('ceo_confirm_monthly_checkbox');
                pageData.lang.ce_error_monthly = app.main.lang('ceo_confirm_monthly_checkbox');
                // pageData.lang.ceo_pv_disclaimer = app.main.strReplace(app.main.lang('ceo_pv_disclaimer'), minPV);
            }

            pageData.settings = app.main.getSettings();
            pageData.profile = app.main.getProfile();
            pageData.preview = app.pws.isPreview();
            pageData.kitsOptional = kitsOptional;
            pageData.kitsMonthly = kitsMonthly;
            pageData.canadaCE = canadaCE;
            pageData.minPV = minPV;
            pageData.stepNavEnabled = stepNavEnabled;
            pageData.gatewayPage = gatewayPage;
            pageData.gaiyoshomenRequired = gaiyoshomenRequired;
            pageData.countries = app.skava.getFieldCountries();
            pageData.states = app.skava.getFieldStates();
            pageData.ceoEnabled = ceoEnabled;
            pageData.become_member_url = app.main.getEnrollURL();

            // for location toggle
            pageData.languageCode = app.main.getCurrentCulture().split('-')[0];
            pageData.languageName = app.location.getCurrentLanguage().language;
            pageData.countryCode = app.main.getCountryCode();
            pageData.countryName = app.main.getCountries()[pageData.countryCode].name;
            pageData.currency = app.global.currency(false, pageData.countryCode);

            // default is true, some regions might change this below
            pageData.er_optin = true;

            // another special case - monthly might be allowed only under certain conditions, if this is false, monthly selections
            // will be visible but disabled vs. monthlyEnabled which removes the monthly option entirely
            pageData.monthlyActive = true;

            // if user culture is different from member, then append default monthly products (without duplicates)
            if (app.main.getCurrentCulture() != app.main.getProfile().culture) {
                if (app.main.getSettings().default_er_products) {
                    var monthlyProducts = enrollmentPackage.product_ids.monthly,
                        defaultProducts = app.main.getSettings().default_er_products.split(',').map(Number);
                    enrollmentPackage.product_ids.monthly = app.main.merge(monthlyProducts, defaultProducts);
                }
            }

            // if the members chosen kit is unavailable, add all available ones that are in stock to the carousel
            var addKits = false;

            // only non-dcp get a carousel if a kit is out of stock or missing
            // or if kits are disabled
            if (!app.main.getSettings().skavaEnabled) {
                if (enrollmentPackage.product_ids.kits.length) {
                    kit = self.getProductByID(enrollmentPackage.product_ids.kits[0]);

                    if (kit) {
                        if (kit.in_stock == false) {
                            addKits = true;
                        }

                    } else {
                        addKits = true;
                    }

                } else {
                    addKits = true;
                }
            }

            // todo: putting this here for because messages aren't publishing on dev
            if (app.main.getCountryCode() === 'au') {
                addKits = false;
            }

            if (addKits == true && !app.main.getSettings().disableKits) {
                // now add all available kits for the carousel
                enrollmentPackage.product_ids.kits = [];

                products.forEach(function(product) {
                    if (product.enrollment == true && product.in_stock == true && product.distributor_point_value >= 10000 && !enrollmentPackage.product_ids.kits.includes(product.product_id)) {
                        enrollmentPackage.product_ids.kits.push(product.product_id);
                    }
                });
            }

            // user always gets the member's selected starter kit
            // unless it is optional for the current country
            // except for global shopping where multiple kits will be available
            // CEO - skip this if a kit was intentionally deselected by the user
            if ((kitsOptional == false || (ceoEnabled == true && kitDeselected == false)) && enrollmentSelected.kits.length < 1) {
                // clear any previosly added kits
                enrollmentSelected.kits = [];

                for (i=0; i<enrollmentPackage.product_ids.kits.length; i++) {
                    kit = self.getProductByID(enrollmentPackage.product_ids.kits[i]);

                    if (kit) {
                        // only choose a kit with a PV greater than 0
                        // but allow it to be chosen if it is the only kit available
                        if (kit.distributor_point_value < 1 && enrollmentPackage.product_ids.kits.length > 1) {
                            continue;
                        }

                        // if there are variants, choose the first one as it may have been sorted by country or sale
                        if (kit.variants) {
                            enrollmentSelected.kits.push(kit.variants[0].item_id);

                        } else {
                            // save the first available item_id, not product_id
                            enrollmentSelected.kits.push(kit.item_id);
                        }

                        self.saveState();
                        break;
                    }
                }
            }

            // loop through each stored product id and construct full product lists for render
            for (k=0; k<keys.length; k++) {
                for (i=0; i<enrollmentPackage.product_ids[keys[k]].length; i++) {
                    var product_id = enrollmentPackage.product_ids[keys[k]][i];

                    search = self.getProductByID(product_id);

                    if (search) {
                        // clone it...
                        search = JSON.parse(JSON.stringify(search));
                        // default quantity 1
                        search.quantity = 1;

                        // only check added if we're on that step - search by item_id, not product_id
                        var index = self.getProductIndex(search.item_id, enrollmentSelected[keys[k]]);

                        // if ((keys[k] == currentStep || keys[k] == 'kits' || currentStep == 'e2' || currentStep == 'subscription') && enrollmentSelected[keys[k]].includes(search.item_id)) {
                        if ((keys[k] == currentStep || keys[k] == 'kits' || currentStep == 'e2' || currentStep == 'subscription') && index > -1) {
                            search.added = true;

                            if (keys[k] == 'kits' && enrollmentSelected[keys[k]][index].isSubscription === true) {
                                search.isSubscription = true;
                            }

                        } else {
                            search.added = false;
                        }

                        // if (enrollmentSelected[keys[k]][index] && enrollmentSelected[keys[k]][index].quantity) {
                        //     search.quantity = enrollmentSelected[keys[k]][index].quantity;
                        //     console.log('setting quantity to', search.quantity);
                        // }

                        // attach selected variant item_id
                        if (typeof product_id == 'object') {
                            search.default_variant = product_id.item_id;

                            if (product_id.quantity) {
                                search.quantity = product_id.quantity;
                            }
                        }

                        // if a kit is out of stock, don't add it
                        if (keys[k] == 'kits' && !search.in_stock) {
                            continue;
                        }

                        var subscriptionField = search.autoship_available;

                        if (app.main.getSettings().skavaEnabled) {
                            subscriptionField = search.can_subscribe || search.subscription;
                        }

                        // if a monthly products autoship_enabled == false, don't add it
                        if (keys[k] == 'monthly' && subscriptionField == false) {
                            // console.log('subscription false for '+ search.name);
                            // console.log(search);
                            continue;
                        }

                        pageData[keys[k]].push(search);

                    } else {
                        console.log('could not find product_id ', enrollmentPackage.product_ids[keys[k]][i]);
                    }
                }

                if (keys[k] == 'kits') {
                    // sort kits by PV from high to low
                    var sortKey = app.main.getSettings().skavaEnabled ? 'point_value' : 'distributor_point_value';
                    app.main.sort(pageData.kits, sortKey, 'desc');

                    // if a previously selected kit isn't at the front of the list, move it
                    if (pageData.kits.length > 0 && pageData.kits[0].added == false) {
                        j = pageData.kits.length;

                        while (j--) {
                            kit = pageData.kits[j];

                            if (kit.added == true) {
                                // remove the added kit
                                pageData.kits.splice(j, 1);
                                // insert it at the front
                                pageData.kits.unshift(kit);
                                break;
                            }
                        }
                    }
                }
            }

            // any special cases per region
            // CA - product guide, er signup
            pageData.include_guide = enrollmentSelected.include_guide;

            if (canadaCE) {
                pageData.er_optin = enrollmentSelected.er_optin;
                pageData.monthlyActive = enrollmentSelected.er_optin;

                // if starter kit has not been selected and er_optin is false, still allow monthly products to be selected
                if (enrollmentSelected.kits.length < 1 && !enrollmentSelected.er_optin) {
                    pageData.monthlyActive = true;
                }

                // special french product guid item, canada only
                // make this an array so it can use the product list partial
                pageData.productGuide = [self.getProductByID(productGuideID)];
            }

            if (app.main.lang('ce_er_optin2') && pageData.kits.length) {
                pageData.lang.ce_er_optin2 = app.main.strReplace(app.main.lang('ce_er_optin2'),
                    '<a href="'+ pageData.kits[0].url +'" data-id="'+ pageData.kits[0].product_id +'">'+ pageData.kits[0].name +'</a>'
                );
            }

            $('body').addClass('enrollment');

            if (enrollmentPackage.name && app.pws.isPreview() == false) {
                pageData.packageName = enrollmentPackage.default ? '' : enrollmentPackage.name;

                if (enrollmentPackage.description) {
                    pageData.packageHeadline = enrollmentPackage.description;

                } else if (enrollmentPackage.headline) {
                    pageData.packageHeadline = enrollmentPackage.headline;
                }
            }

            // add additional products option for bundle checkout
            pageData.allowAdditionalProducts = false;

            if (!enrollmentPackage.preselected && enrollmentPackage.allowAdditionalProducts == true) {
                pageData.allowAdditionalProducts = true;
            }

            switch (currentStep) {
                case 'gateway':
                    // clear any previously selected products if returning to this page to avoid cases where monthly products were selected, then
                    // user returns and chooses the product path instead
                    keys.forEach(function(key) {
                        enrollmentSelected[key] = [];
                    });
                break;

                case 'brand':
                    // if a previously selected kit isn't at the front of the list, move it
                    if (pageData.bundles.length > 0 && !pageData.bundles[0].added) {
                        j = pageData.bundles.length;

                        while (j--) {
                            bundle = pageData.bundles[j];

                            if (bundle.added === true) {
                                // remove the added bundle
                                pageData.bundles.splice(j, 1);
                                // insert it at the front
                                pageData.bundles.unshift(bundle);
                                break;
                            }
                        }
                    }
                break;

                case 'products':
                    /* disable now that we're using gateway for the brand homepage */
                    /*
                    if (gatewayPage && monthlyEnabled == true && app.pws.isPreview() == false) {
                        // monthly ce was chosen, jump to it
                        app.page.loadPage('build/monthly', true);
                        return false;
                    }
                    */

                    // skip to next step products aren't available + kits aren't required and none have been selected in admin
                    if (kitsOptional && (enrollmentPackage.product_ids.kits.length < 1 && enrollmentPackage.product_ids.products.length < 1)) {
                        app.page.loadPage('build/e2', true);
                    }

                    app.page.setTitle([
                        app.main.lang('pws_ce_flag'),
                        app.main.lang('ce_additional_products')
                    ]);

                    //productList = enrollmentSelected.products;
                    $('body').removeClass('enrollment');
                break;

                case 'e2':
                case 'monthly':
                case 'subscription':
                    // some regions don't allow monthly, or standard was chosen on the gateway page, so go back to the product step
                    if ((monthlyEnabled === false && app.pws.isPreview() == false) || (app.pws.isPreview() == false && gaiyoshomenRequired && !enrollmentSelected.gaiyoshomen)) {
                        app.page.loadPage('build/products', true);
                        return;
                    }

                    // skip this step if no monthly products are available
                    if (!app.main.getSettings().skavaEnabled) {
                        if (enrollmentPackage.product_ids.monthly.length < 1) {
                            app.page.loadPage('build/review', true);
                            return;
                        }
                    }

                    app.page.setTitle([
                        app.main.lang('pws_ce_flag'),
                        app.main.lang('ce_monthly_subscription')
                    ]);

                    if (currentStep == 'e2') {
                        pageData.e2 = enrollmentSelected.e2;
                        pageData.selectedKits = [];

                        enrollmentSelected.kits.forEach(function(kit_item_id) {
                            pageData.selectedKits.push(self.getProductByID(kit_item_id, 'item_id'));
                        });

                        if (pageData.selectedKits.length) {
                            if (pageData.selectedKits[0].distributor_point_value < 9000) {
                                pageData.skipStep2 = true;
                                delete enrollmentSelected.e2.step2;
                            }

                        } else {
                            pageData.skipStep2 = true;
                            delete enrollmentSelected.e2.step2;
                        }

                        self.checkMinPV();

                        // learn more url
                        pageData.learnMore = 'https://www.youngliving.com/'+ app.main.getYLCulture() +'/opportunity/essential-rewards';
                        pageData.learnMoreRemote = true;

                        if (['us', 'ca'].includes(app.main.getCountryCode())) {
                            // local learn more page
                            pageData.learnMore = '#learnmore';
                            pageData.learnMoreRemote = false;
                        }

                        // terms & conditions urls are not consistent, so add here as needed
                        var termsURL = 'https://static.youngliving.com/';

                        switch (app.main.getCountryCode()) {
                            case 'au':
                            case 'nz':
                                termsURL = 'https://library.youngliving.com/en/'+ app.main.getCountryCode() +'/Benefits-of-Enrolling-in-Essential-Rewards/159298317';
                            break;

                            case 'at':
                            case 'de':
                                termsURL += 'EU-DOCS/PDFS/Essential_Rewards/2019/Essential_Rewards_Application_Form_DE.pdf';
                            break;

                            case 'gb':
                                termsURL += 'EU-DOCS/PDFS/Essential_Rewards/2019/Essential_Rewards_Application_Form_EN_GB.pdf';
                            break;

                            case 'hk':
                                termsURL += 'en-HK/PDFS/LEGAL/MemberAgreement_201612.pdf';
                            break;

                            case 'us':
                                if (app.main.getLanguageCode() == 'ES') {
                                    termsURL += 'es-US/PDFS/ER_Agreement_Terms_and_Conditions_es_US.pdf';

                                } else {
                                    termsURL += 'en-US/PDFS/ER_Agreement_Terms_and_Conditions_en_US.pdf';
                                }
                            break;

                            default:
                                // don't show for other regions
                                termsURL = false;
                            break;
                        }

                        pageData.termsURL = termsURL;

                        // if (ceoEnabled && enrollmentSelected.kits.length == 0) {
                        //     pageData.hideMonthlyTitle = true;
                        // }
                    }
                break;

                case 'review-checkout':
                    // this one's admin preview only
                    if (!app.pws.isPreview()) {
                        app.page.loadPage('build/review', true);
                        return;
                    }
                    pageData.packageURL = 'myyl.com/'+ app.main.getSitePath() +'/#bwm/'+ enrollmentPackage.slug;
                break;

                case 'review':
                    if (app.pws.isPreview()) {
                        // auto-check all products in the enrollment package
                        self.selectAllProducts();
                    }

                    if (app.pws.isPreview() == false && gaiyoshomenRequired && !enrollmentSelected.gaiyoshomen) {
                        app.page.loadPage('build/products', true);
                        return;
                    }

                    // special case for regions where no purchase is necessary at all, so skip the review step and jump to
                    // the membership step if no products have been selected
                    // todo: right now this is based on kits being optional - may need to expand on that for other regions down the road
                    if (kitsOptional === true && !app.main.getSettings().skavaEnabled) {
                        if (enrollmentSelected.kits.length + enrollmentSelected.products.length + enrollmentSelected.monthly.length == 0) {
                            app.page.loadPage('build/membership', true);
                            return;
                        }
                    }

                    app.page.setTitle([
                        app.main.lang('pws_ce_flag'),
                        app.main.lang('ce_review_order')
                    ]);

                    self.setProductQuantities();

                    for (k=0; k<keys.length; k++) {
                        pageData[keys[k]] = [];

                        for (i=0; i<enrollmentSelected[keys[k]].length; i++) {
                            search = self.getProductByID(enrollmentSelected[keys[k]][i], 'item_id');

                            // // check for quantity and attach
                            // if (enrollmentSelected[keys[k]][i].quantity) {
                            //     search.quantity = enrollmentSelected[keys[k]][i].quantity;
                            //     console.log('setting another quantity to', search.quantity);

                            // } else {
                            //     // just in case attempt to delete any previously attached quantity
                            //     delete search.quantity;
                            // }

                            if (search) {
                                // check if a kit is set as a subscription
                                if (enrollmentSelected[keys[k]][i].isSubscription === true) {
                                    search.isSubscription = true;

                                } else {
                                    delete search.isSubscription;
                                }

                                pageData[keys[k]].push(search);

                            } else {
                                // console.log('product id '+ enrollmentSelected[keys[k]][i] +' not found');
                            }
                        }
                    }

                    // check that products have been selected
                    var emptyProducts = 0;

                    for (k=0; k<keys.length; k++) {
                        // if all items are out of stock, enrollment selected will be empty
                        if (!enrollmentSelected[keys[k]].length) {
                            emptyProducts++;
                        }
                    }

                    pageData.gifts = app.skava.getCartGifts();
                    pageData.PSKMonth1 = enrollmentSelected.e2.step2 ? true : false;
                    self.calcTotals();
                    pageData.ce_pv_reward_copy = app.main.lang(self.getPVRewardKey());
                    pageData.preselected = enrollmentPackage.preselected;
                    steps.review = true;
                    pageData.allowRemove = app.main.getSettings().skavaEnabled ? true : false;

                    // preselected carts cannot remove items
                    if (enrollmentPackage.preselected) {
                        pageData.allowRemove = false;
                    }

                    app.main.track('CART', 'Review');

                    if (emptyProducts == 3) {
                        // if preselected and empty, that means all chosen products are out of stock
                        if (enrollmentPackage.preselected) {
                            pageData.cartOutOfStock = true;
                            console.log('no products in cart');

                        } else {
                            // no products selected!
                            pageData.noProductsSelected = true;
                        }
                    }

                    // for the additional products section
                    pageData.categories = categories;
                break;

                // case 'additional':
                //     pageData.categories = categories;
                //     console.log(categories);
                // break;

                // todo: this can be removed when the new skava steps are ready
                case 'membership':
                    // get xsrf token
                    app.page.setTitle([
                        app.main.lang('pws_ce_flag'),
                        'VO Redirect'
                    ]);

                    app.modal.load('enrollment-redirect-modal');

                    self.getResponse({
                        url: servicesURL[mode] +'xsrf-token',
                        method: 'POST'

                    }, function(response, xhr) {
                        self.getEnrollmentRedirect(app.cookie.get('XSRF-TOKEN'));

                    }, function(e) {
                        // error
                        app.message.error('Error getting xsrf token');
                        console.log(e);
                    }, 'text');

                    return;
                //break;

                case 'info':
                    // if anything needs to happen pre-render for the info step, it can go here
                       // loop through each stored item_id and construct full product lists for render
                    for (k=0; k<keys.length; k++) {
                        pageData[keys[k]] = [];

                        for (i=0; i<enrollmentSelected[keys[k]].length; i++) {
                            search = self.getProductByID(enrollmentSelected[keys[k]][i], 'item_id');

                            if (keys[k] == 'kits' && enrollmentSelected[keys[k]][i].isSubscription === true) {
                                search.isSubscription = true;
                            }

                            if (search) {
                                pageData[keys[k]].push(search);
                            }
                        }
                    }

                    pageData.totals = self.calcTotals();
                    pageData.PSKMonth1 = enrollmentSelected.e2.step2 ? true : false;
                    steps.info = true;
                    self.renderInfo(pageData);
                break;

                case 'checkout':
                    // if anything needs to happen pre-render for the info step, it can go here
                    // loop through each stored item_id and construct full product lists for render
                    for (k=0; k<keys.length; k++) {
                        pageData[keys[k]] = [];

                        for (i=0; i<enrollmentSelected[keys[k]].length; i++) {
                            search = self.getProductByID(enrollmentSelected[keys[k]][i], 'item_id');

                            if (search) {
                                pageData[keys[k]].push(search);
                            }
                        }
                    }

                    pageData.totals = self.calcTotals();
                    // pageData.PSKMonth1 = enrollmentSelected.e2.step2 ? true : false;
                    steps.info = true;
                    self.renderInfo(pageData);
                break;

                case 'welcome':
                    if (welcomeData === null) {
                        $.getJSON(commonURL[mode] + app.main.getCurrentCulture() +'/ce-welcome.json', function(data) {
                            welcomeData = data;
                            self.renderWelcome(pageData);
                        });
                    } else {
                        self.renderWelcome(pageData);
                    }
                    return;
                //break;
            }

            // use this to skip the monthly step when no monthly products are available
            // or if a region doesn't allow it
            pageData.skipMonthly = (enrollmentPackage.product_ids.monthly.length > 1 ? false : true);

            // if a region doesn't allow monthly, override the previous setting
            if (monthlyEnabled === false) {
                pageData.skipMonthly = true;
            }

            if (requestedSlug) {
                pageData.requestedSlug = '/'+ requestedSlug;
            }

            pageData.monthlyConfirmed = monthlyConfirmed;
            self.checkSteps();
            pageData.steps = steps;
            pageData.currentStep = currentStep;

            // multiple kits are available in the carousel
            pageData.kitsMultiple = pageData.kits.length > 1;

            // render the page - all logic after this can affect page elements
            if (refreshCart === true) {
                $('#review-left').html(app.main.getTemplate('enrollment-review-left', pageData));
                // refreshCart = false;

            } else {
                $('#page').html(app.main.getTemplate('enrollment-'+ currentStep, pageData));
                $('#review-left').html(app.main.getTemplate('enrollment-review-left', pageData));
            }

            // in case this is on the page
            $('#min-pv').text(minPV);

            if (app.main.getSettings().unified_shopping_enabled) {
                app.main.hideHeaderRight(false);

                // hide lang switcher and enroll link
                $('#inner-right').hide();

                // send true to notifiy cart that his is a unified shopping enrollment
                app.cart.init(products, true);

            } else {
                $('.header-right').hide();
            }

            // if (kitDeselected) {
            //     $('#additional-products').addClass('is-disabled');
            // }

            // init carousel for the products step if more than one kit is available or special case for AU kits also appear on monthly step
            if ((currentStep == 'products' || currentStep == 'subscription') || (app.main.getCurrentCulture() == 'en-au' && (currentStep == 'monthly' || currentStep == 'e2')) && pageData.kits.length > 1) {
                if (kitsOptional == false) {
                    $('.slide-container').addClass('required');
                }

                var $slides = $('.slide-container .product.kit');

                if (app.main.getSettings().product_card_enabled) {
                    $slides = $('.slide-container .product-card.type-bundle');
                }

                var totalSlides = $slides.length;

                if (totalSlides > 1) {
                    carousel = new Siema({
                        selector: '.slide-container',
                        duration: 300,
                        easing: 'ease-out',
                        perPage: 1,
                        startIndex: 0,
                        draggable: true,
                        multipleDrag: true,
                        threshold: 100,
                        dragThreshold: 10,
                        loop: false,
                        rtl: false,
                        onInit: function() {
                            //
                        },
                        onChange:function() {
                            $('.control').removeClass('is-disabled');

                            if (this.currentSlide == 0) {
                                $('.control.prev').addClass('is-disabled');
                            }

                            if (this.currentSlide == totalSlides-1) {
                                $('.control.next').addClass('is-disabled');
                            }
                        },
                        onDragStart: function() {
                            app.productcard.setIsDragging(true);
                        },
                        onDragEnd: function() {
                            window.setTimeout(function() {
                                app.productcard.setIsDragging(false);
                            }, 50);
                        }
                    });

                    $('.control.prev').on('click', function(e) {
                        e.preventDefault();
                        carousel.prev();
                    });

                    $('.control.next').on('click', function(e) {
                        e.preventDefault();
                        carousel.next();
                    });
                }

            } else {
                // single kit? remove carousel controls
                $('.carousel.kits .control').remove();
            }

            if (currentStep == 'subscription') {
                // enable/disable add to cart button
                if (self.checkIfSelectedProducts()) {
                    $('.btn-next').removeClass('is-disabled');

                } else {
                    $('.btn-next').addClass('is-disabled');
                }
            }

            // location chooser special case for CE
            app.location.enableCustomEnrollment(function(val) {
                self.validateCulture(val);
            });

            app.location.setToggle('enrollment-location-toggle');

            if (currentStep == 'review') {

                if (app.main.getSettings().skavaEnabled) {
                    $('#promo-container').html(app.main.getTemplate('promo-form', {}));
                    app.skava.initPromoForm();

                    if (refreshCart === false) {
                        // add the additional products search carousel
                        $('#additional-products-search').html(app.main.getTemplate('enrollment-additional', pageData));
                        // self.initProductSearch();
                        app.productsearch.enable('enroll');

                        $('.link-additional-products').on('click', function(e) {
                            e.preventDefault();
                            $('#additional-products-bundle').addClass('is-open');
                            app.main.scrollTo('additional-products-search');
                            $('.field-product-search').focus();
                        });
                    }

                    // remove link click events
                    $('.cart-remove-link').off().click(function(e) {
                        e.preventDefault();
                        var itemId = $(this).data('item-id'),
                            isSubscription = $(this).data('is-subscription'),
                            quantity = 1, // irrelevant when removing
                            productType = isSubscription ? 'monthly' : 'regular';

                        console.log('remove item_id '+ itemId);
                        self.toggleProduct(itemId, currentStep, true, productType, quantity);

                        // also remove from skava cart
                        var cartItem = app.skava.findItem(itemId+ '_1', isSubscription);

                        if (cartItem && cartItem.itemId) {
                            self.deleteSkavaItem(cartItem.itemId, self.refreshReview);

                        } else {
                            console.log(itemId +' not found for deletion');
                            self.refreshReview();
                        }
                    });

                    $('#link-loyalty').off().on('click', function(e) {
                        e.preventDefault();
                        var domain = 'www';

                        if (['local', 'dev'].includes(mode)) {
                            domain = 'clone';
                        }

                        window.open('https://'+ domain +'.youngliving.com/us/en/myaccount/subscriptions', '_blank');
                    });

                    $('#field-bundle-loyalty').off().on('change', function(e) {
                        if (enrollmentSelected.kits[0]) {
                            enrollmentSelected.kits[0].isSubscription = !e.target.checked;
                            self.saveState();
                            app.page.showLoader();
                            self.resetKits(self.refreshReview);
                        }
                    });
                }
            }

            // subscription interval toggle
            $('#subscription-interval-toggle').off().on('click', function() {
                if (!$(this).hasClass('is-active')) {
                    $('#subscription-interval-hidden-input').focus();
                    $(this).addClass('is-active');

                } else {
                    $(this).removeClass('is-active');
                }
            });

            $('#subscription-interval-hidden-input').off().on('blur', function (e) {
                var activeElements = $(':active');
                for (var i = 0; i < activeElements.length; i++) {
                    if (activeElements[i].id === 'subscription-interval-container') {
                        return;
                    }
                }
                $('#subscription-interval-toggle').removeClass('is-active');
            });

            $('#subscription-interval-toggle .interval-option').off().on('click', function () {
                var id = $(this).attr('data-option-id');
                if (id === 'monthly') {
                    $('#subscription-interval-text').html('Every Month');
                } else {
                    $('#subscription-interval-text').html('Every Year');
                }
            });

/*
            // bundle-add
            $('.bundle-list .bundle-add').off().on('click', function() {
                var bundleId = $(this).attr('data-product_id');
                var bundle = self.getProductByID(bundleId);

                if (bundle) {
                    for (var i = 0; i < bundles.length; i++) {
                        bundles[i].added = false;
                    }
                    if (!enrollmentSelected.bundles) {
                        enrollmentSelected.bundles = [];
                    }
                    if (enrollmentSelected.bundles.length > 0) {
                        enrollmentSelected.bundles = [];
                    }
                    enrollmentSelected.bundles.push(bundleId);
                    enrollmentSelected.partnerType = 'brand';
                    self.saveState();
                    app.page.loadPage('build/brand');
                }
            });

            // partner option links
            $('.partner-option').off().on('click', function() {
                enrollmentSelected.partnerType = $(this).attr('data-partner-option');
                self.saveState();
                app.page.loadPage($(this).attr('data-partner-path'));
            });
*/

            if (currentStep == 'gateway') {
                // remove the extra bottom margin
                $('body').removeClass('enrollment');

                $('.help-tip').off('click').on('click', function() {
                    self.showMonthlyMessage(true);
                });

                $('.btn-next.products').on('click', function(e) {
                    monthlyEnabled = false;
                    kitsMonthly = false;
                    enrollmentSelected.er_optin = false;
                    self.saveState();
                });

                $('.btn-next.monthly').on('click', function(e) {
                    monthlyEnabled = true;
                    kitsMonthly = true;
                    enrollmentSelected.er_optin = true;
                    self.saveState();
                });
            }

            if (currentStep == 'monthly') {
                if (app.pws.isPreview() == false) {
                    self.showMonthlyMessage();
                }

                $('.help-tip').off('click').on('click', function() {
                    self.showMonthlyMessage(true);
                });
            }

            self.addProductClickHandlers();

            if (app.pws.isPreview()) {
                self.initPreview();
            }

            $('#confirm-monthly').on('click', function() {
                $(this).toggleClass('is-active');
                monthlyConfirmed = !monthlyConfirmed;
                app.message.clear('monthly-confirm');

                // if (ceoEnabled && !enrollmentSelected.kits.length) {
                // now minPV is required whether a kit is selected or not
                if (ceoEnabled) {
                    if (monthlyConfirmed) {
                        if (totalPV < minPV) {
                            self.openPvErrorModal();
                        }
                    }

                    self.calcTotals();
                    $('#min-pv').text(minPV);
                }
            });

            $('#btn-monthly-next').on('click', self.validateMonthly);

            if (ceoEnabled) {
                $('#btn-next-products').on('click', function() {
                    if (kitDeselected && pvProducts < minPVceo) {
                        self.openCEOBar();

                    } else {
                        app.page.loadPage(self.getPath('build/e2'));
                    }
                });
            }

            // This will adjust product ids for variant dropdowns that have been marked as selected
            // variant_id: the item_id for this variant (not product_id as that is the same as the parent and will not work)
            $('.product select').find(':selected').each(function() {
                var variant_id = parseInt($(this).val(), 10),
                    product_id = parseInt($(this).parent().data('parent'), 10),
                    // not proud of this
                    productType = $(this).parent().parent().parent().attr('data-product-type');

                self.switchVariant(
                    variant_id,
                    product_id,
                    self.findVariant(variant_id, $(this).hasClass('kit'), productType),
                    productType
                );
            });

            $('.btn-back, .btn-next, #btn-monthly-next, .edit').on('click', function() {
                app.main.track('CE', $(this).data('trackingaction'));
            });

            $('.enroll-yl a').on('click', function() {
               app.main.track('CE', 'cta-enroll-thru-yl-clicked');
            });

            // for JP
            if (gaiyoshomenRequired) {
                $('#ewm-container').addClass('is-disabled');

                if (app.pws.isPreview()) {
                    // in preview mode, simulate a valid number
                    enrollmentSelected.gaiyoshomen = '12345';
                }

                if (enrollmentSelected.gaiyoshomen) {
                    $('#field-gaiyoshomen').val(enrollmentSelected.gaiyoshomen);
                    $('#field-student-no').prop('checked', true);
                    $('#ewm-container').removeClass('is-disabled');
                    $('#gaiyoshomen-message').text(app.main.lang('gaiyoshomen_valid')).removeClass('is-disabled');
                    $('#gaiyoshomen-container').addClass('valid').removeClass('invalid');
                    $('#gaiyoshomen-container').removeClass('is-disabled');
                    $('#gaiyoshomen-denied').addClass('is-disabled');
                }

                $('#field-gaiyoshomen').on('keyup', function() {
                    $('#gaiyoshomen-message').empty().addClass('is-disabled');
                    $('#gaiyoshomen-container').removeClass();

                    if ($(this).val()) {
                        $('#btn-gaiyoshomen').removeClass('is-disabled');

                    } else {
                        $('#btn-gaiyoshomen').addClass('is-disabled');
                    }
                });

                $('#field-student-yes').on('click', function() {
                    $('#ewm-container').addClass('is-disabled');
                    $('#gaiyoshomen-container').val('').removeClass().addClass('is-disabled');
                    $('#gaiyoshomen-message').addClass('is-disabled').empty();
                    //$('#gaiyoshomen-container').addClass('is-disabled');
                    $('#gaiyoshomen-denied').removeClass('is-disabled');
                });

                $('#field-student-no').on('click', function() {
                    $('#gaiyoshomen-container').removeClass('is-disabled');
                    $('#gaiyoshomen-denied').addClass('is-disabled');
                });

                $('#btn-gaiyoshomen').on('click', function(e) {
                    $.post('https://www.youngliving.com/api/accounts/gaiyoshomen', {
                        validationCode: $('#field-gaiyoshomen').val()
                    })
                    .done(function(data) {
                        if (data.isValid === true) {
                            $('#ewm-container').removeClass('is-disabled');
                            $('#gaiyoshomen-message').text(app.main.lang('gaiyoshomen_valid')).removeClass('is-disabled');
                            $('#gaiyoshomen-container').addClass('valid').removeClass('invalid');

                            //set cookie allowing this to be enabled upon refresh
                            enrollmentSelected.gaiyoshomen = $('#field-gaiyoshomen').val();
                            self.saveState();

                        } else {
                            // invalid number
                            $('#ewm-container').addClass('is-disabled');
                            $('#gaiyoshomen-message').text(app.main.lang('gaiyoshomen_invalid')).removeClass('is-disabled');
                            $('#gaiyoshomen-container').addClass('invalid').removeClass('valid');

                            delete enrollmentSelected.gaiyoshomen;
                            self.saveState();

                        }
                    })
                    .fail(function(error) {
                        console.log(error);
                    });
                });
            }

            // e2
            // clear any previously stored data if e2 is disabled
            if (!app.main.getSettings().v2_enrollment_enabled && enrollment.e2) {
                delete enrollmentSelected.e2;
                self.saveState();
            }

            // CEO
            if (app.main.getSettings().v2_enrollment_enabled && ceoEnabled && currentStep == 'e2') {
                // clear pushdown from previous page if present
                app.message.clear('ceo-pv-message');

                $('.e2-step1, .e2-step2').hide();
                // must enroll
                self.e2Option('step1', true);

                // if no kit is chosen, don't set the step2 option
                // if kis is present, step2 should be set to true
                if (enrollmentSelected.kits.length) {
                    self.e2Option('step2', true);

                } else {
                    pageData.skipStep2 = true;
                    delete enrollmentSelected.e2.step2;
                }
                self.saveState();
            }

            if (app.main.getSettings().v2_enrollment_enabled && currentStep == 'e2') {
                // step1
                $('.e2-step1 button').off('click').on('click', function() {
                    // selecting no should clear any previously selected items and go to the checkout page
                    if ($(this).hasClass('btn-no')) {
                        self.e2Reset();
                        app.page.loadPage('build/review');
                        app.main.track('EwM', 'Join ER', 'No');
                        return;
                    }

                    if ($(this).hasClass('is-selected')) {
                        self.e2EnableSection('step2');

                    } else {
                        self.e2Option($(this).data('option'), $(this).hasClass('btn-yes'));
                        app.main.track('EwM', 'Join ER', 'Yes');
                    }
                });

                // step2
                $('.e2-step2 button').off('click').on('click', function() {
                    if ($(this).hasClass('is-selected')) {
                        self.e2EnableSection('step3');

                    } else {
                        self.e2Option($(this).data('option'), $(this).hasClass('btn-yes'));

                        if ($(this).hasClass('btn-yes')) {
                            $('.e2-step3 .subhead').text(app.main.lang('e2_step3_copy_month2'));
                            app.main.track('EwM', 'PSK ER', 'Yes');
                        } else {
                            $('.e2-step3 .subhead').text(app.main.lang('e2_step3_copy_month1'));
                            app.main.track('EwM', 'PSK ER', 'No');
                        }
                    }
                    self.calcTotals();
                });

                // step3
                if (!ceoEnabled) {
                    $('.confirm').hide();
                }

                // enable any previously set options
                if (enrollmentSelected.e2.step1 !== undefined) {
                    self.e2Option('step1', enrollmentSelected.e2.step1, true);
                }

                if (enrollmentSelected.e2.step2 !== undefined) {
                    self.e2Option('step2', enrollmentSelected.e2.step2, true);
                }
            }

            // add additional products to a bundle
            // this step won't exist in non-skava markets
            // if (currentStep == 'additional') {
            //     self.initProductSearch();
            // }

            self.calcTotals();
            app.modal.init();
        },

        // for new bundle options, first clear kits from the skava cart so they can be re-added with different subscription option
        resetKits: function(callback) {
            var cartData = app.skava.getCartData();

            if (cartData && cartData.items) {
                for (var i = 0; i < cartData.items.length; i++) {
                    var sku = cartData.items[i].skus[0];
                    var productId = parseInt(sku.productId);
                    var cartProduct = self.getProductByID(productId, 'product_id');

                    for (var x = 0; x < enrollmentSelected.kits.length; x++) {
                        var id = enrollmentSelected.kits[x];

                        if (enrollmentSelected.kits[x].item_id) {
                            id = enrollmentSelected.kits[x].item_id;
                        }

                        if (id == cartProduct.item_id) {
                            self.deleteSkavaItem(cartData.items[i].itemId, callback);
                        }
                    }
                }
            }
        },

        deleteSkavaItem: function(itemId, callback) {
            app.skava.sendRequest({
                url: '/cart/'+ itemId +'/',
                method: 'DELETE'
            },
            function() {
                // success
                console.log('deleted '+ itemId);
                if (typeof callback == 'function') {
                    callback();
                }

            },
            function() {
                // error
                console.log('failed to delete '+ itemId);
            });
        },

        // initialize each product item in the bundle additional products carousel
        initAdditionalCart: function() {
            // add to cart button click event
            $('.cart-add').off().click(function(e) {
                var productId;
                e.preventDefault();

                try {
                    var isSubscription = false;
                    if (app.main.getSettings().skavaEnabled) {
                        productId = $(e.target).attr('data-product_id');
                        var oneTimeOrder = $('#' + productId + '-one-time-order')[0].checked;
                        if (oneTimeOrder) {
                            isSubscription = false;

                        } else {
                            isSubscription = true;
                        }
                    }

                    var itemId = $(e.target).data('item_id'),
                        quantity = parseInt($(e.target).siblings('.select').find('input.field-quantity').val(), 10),
                        productType = isSubscription ? 'monthly' : 'regular';

                    self.toggleProduct(itemId, currentStep, false, productType, quantity);

                    // also add it to the current enrollmentPackage
                    self.addAdditionalProduct(itemId, quantity, isSubscription);

                    var addProduct = [{
                        quantity: quantity,
                        skus: [
                            {
                                skuId: itemId.toString() +'_1',
                                productId: productId,
                                type: "DEFAULT"
                            }
                        ],
                        properties: {},
                        isSubscription: isSubscription
                    }];

                    app.skava.sendRequest({
                        url: '/cart/',
                        method: 'POST',
                        data: JSON.stringify(addProduct)
                    }, 

                    function(data) {
                        // button success state
                        if ($(e.target).hasClass('cart-success')) {
                            // removed
                            $(e.target).html(app.main.lang('add_to_cart_cta')).removeClass('cart-success');

                        } else {
                            // added
                            $(e.target).html('<i></i>'+ app.main.lang('added_to_cart_cta')).addClass('cart-success');
                        }

                        // re-render without a full update
                        self.refreshReview(true);
                    },

                    function(err) {
                        console.log(err);
                    });
                }

                catch(err) {
                    console.log(err);
                    app.main.track('Product', 'ga-add-to-cart-error');
                }
            });

            // make buttons active
            $('.cart-disabled').removeClass('cart-disabled');
            $('.cart-hidden').removeClass('cart-hidden');

            // show cart item options for first varient items (since it's what's shown by default in pick-list)
            $('pws-item:first-child').addClass('active');

            // init quantity select (add additional)
            $('.add-to-cart .selected').off().on('click', function() {
                var pos = $(this).offset(),
                    $parent = $(this).parent(),
                    $select = $('#select-list');

                if ($parent.hasClass('is-active')) {
                    self.closeSelect();

                } else {
                    self.closeSelect();
                    $parent.addClass('is-active');
                    $(window).on('resize', self.closeSelect);

                    $select.css({
                        top: Math.round(pos.top) + 37,
                        left: Math.round(pos.left)
                    }).show();

                    $('li:not(.other)', $select).on('click', function() {
                        self.setQty($parent, $(this).text());
                        self.closeSelect();
                    });
                }

                $('li.other input', $select)
                    .on('keyup blur', function(e) {
                        var num = $(this).val().replace(/\D/g, '');
                        $(this).val(num);

                        switch (e.keyCode) {
                            // enter/return
                            case 13:
                                self.setQty($parent, num);
                                self.closeSelect();
                            break;
                            // esc
                            case 27:
                                self.closeSelect();
                            break;
                        }
                    })
                    .on('focus', function() {
                       // disable the document mousdown handler so the blur event will take precedence
                       $('body,.carousel').off('mousedown touchstart');
                    })
                    .on('blur', function() {
                        if ($(this).val()) {
                            self.setQty($parent, $(this).val());
                            self.closeSelect();
                        }
                    });

                // close the select drop-down when anything else is clicked
                $('body,.carousel').off().on('mousedown touchstart', function(e) {
                    // ignore on the select-list element or quantity field inside it (other)
                    if (e.target.parentElement.id != 'select-list' && e.target.parentElement.className != 'other') {
                        self.closeSelect();
                        $('body,.carousel').off('mousedown touchstart');
                    }
                });
            });

            $('.variants-wrapper select').on('touchstart mousedown', function(e) {
                $(this).focus();
            });

            // handle variant options switching
            $('.variants-wrapper select').change(function(e) {
                app.pws.switchVariant($(this).data('family'), $(this).val());

                window.dataLayer.push({
                    event: 'selectVariant',
                    selection: this.value
                });
            });

            $('.variants-wrapper select').each(function() {
                app.pws.switchVariant($(this).data('family'), $(this).find(':selected').val());
            });
        },

        /**
         * Refreshes the cart section of the review page
         */
        refreshReview: function(openSearch) {
            // go back to bundle if cart is emptied
            if (self.checkIfSelectedProducts() === false) {
                refreshCart = false;
                app.page.loadPage('build/subscription/'+ requestedSlug, true);
                return;
            }

            refreshCart = true;
            self.render({}, function(data) {
                if (openSearch === true) {
                    $('#additional-products-bundle').addClass('is-open');
                    // re-enable additional product card in case search isn't refreshed
                    app.productcard.enable('additional');
                }
            });
        },

        /**
         * Sets the chosen option to true/false, creates the node if necessary
         * Also toggles other steps when changing a previous one
         * target: the current option [step1 | step2]
         * val: value to set the option to [true | false | null]
         * refresh: if true, will not reset previous options to null - used when reloading the page
         */
        e2Option: function(target, val, refresh) {
            if (!enrollmentSelected.e2) {
                enrollmentSelected.e2 = {};
            }

            if (val === undefined) {
                val = null;
            }

            if (val === true) {
                $('.btn-no', $('.e2-'+ target)).removeClass('is-selected');
                $('.btn-yes', $('.e2-'+ target)).addClass('is-selected');
                enrollmentSelected.e2[target] = true;

            } else if (val === false) {
                $('.btn-no', $('.e2-'+ target)).addClass('is-selected');
                $('.btn-yes', $('.e2-'+ target)).removeClass('is-selected');
                enrollmentSelected.e2[target] = false;

            } else {
                if (!refresh) {
                    $('.btn-no', $('.e2-'+ target)).removeClass('is-selected');
                    $('.btn-yes', $('.e2-'+ target)).removeClass('is-selected');
                    $('.e2-'+ target).addClass('is-disabled');
                    delete enrollmentSelected.e2[target];
                }
            }

            switch (target) {
                case 'step1':
                    if (!refresh) {
                        self.e2Option('step2', null);
                    }

                    if (val === true) {
                        self.e2EnableSection('step2');
                    }
                break;

                case 'step2':
                    if (refresh) {
                        $('.e2-step2').removeClass('is-disabled');
                    }

                    if (val !== null) {
                        self.e2EnableSection('step3');
                    }
                break;
            }

            self.saveState();
        },

        /**
         *  Enable the specified e2 section
         */
        e2EnableSection: function(target) {
            if (target == 'step2' && pageData.skipStep2) {
                target = 'step3';
            }

            if (ceoEnabled) {
                $('.e2-'+ target).removeClass('is-disabled');
                return;
            }

            // slight delay
            setTimeout(function() {
                $('html,body').stop().animate({
                    'scrollTop': $('.e2-'+ target).offset().top - ($('header').height() + $('.member-info').height())
                }, 900, 'swing', function() {
                    $('.e2-'+ target).removeClass('is-disabled');
                });
            }, 200);
        },

        /**
         * Reset E2 to default state
         */
        e2Reset: function() {
            // clears this step and any previously activated steps
            self.e2Option('step1', null);

            // leave step1 section active
            $('.e2-step1').removeClass('is-disabled');

            // clear any previously chosen monthly items
            $('.btn-add.is-active').click();
            $('.btn-add').addClass('is-disabled');
            $('.e2-step3').addClass('is-disabled');

            enrollmentSelected.e2 = {};
            enrollmentSelected.monthly = [];
            self.saveState();
        },

        /**
         * Add all products from the enrollmentPackage to enrollmentSelected, converting product_id to item_id
         */
        selectAllProducts: function(autoSelect) {
            keys.forEach(function(key) {
                enrollmentSelected[key] = [];

                if (autoSelect === true) {
                    enrollmentPackage.product_ids[key].forEach(function(id) {
                        var product = self.getProductByID(id);

                        if (typeof id == 'object') {
                            // choose the default variant instead
                            product = self.getProductByID(id.item_id, 'item_id');
                        }

                        if (product) {
                            if (product.in_stock == true) {
                                // if user is signed in, check if already subscribed
                                if (key == 'monthly' && app.skava.hasSubscriptions(product.product_id)) {
                                    // do nothing
                                    console.log('already subscribed to '+ product.name);
                                    return;
                                }

                                if (key == 'kits') {
                                    // only auto-select the first in-stock kit as skava only accepts one kit per order
                                    if (enrollmentSelected.kits.length < 1) {

                                        // pre-selected cart kit defaults to subscription
                                        var kit = {
                                            product_id: product.product_id,
                                            item_id: product.item_id,
                                            quantity: 1,
                                            isSubscription: true
                                        };

                                        enrollmentSelected.kits.push(kit);
                                    }

                                } else {
                                    if (typeof id == 'object') {
                                        enrollmentSelected[key].push(id);

                                    } else {
                                        enrollmentSelected[key].push(product.item_id);
                                    }
                                }

                            }
                        }
                    });
                }
            });
        },

        /**
         * Figures out which steps have already been seen and are valid, for adding the dot below the # in the step counter
         */
        checkSteps: function() {
            // this is an optional step, so if it's simply been visited then it'll get marked true
            // if false, then check if monthly products have been added
            if (steps.monthly === false) {
                steps.monthly = enrollmentSelected.monthly.length > 0;
            }
        },

        /**
         * Send X-XSRF-TOKEN and enrollment package data to back end to get enrollment URL, then redirect to the URL
         */
        getEnrollmentRedirect: function(token) {
            var data = {
                    enroller_id: app.main.getProfile().member_id,
                    sponsor_id: app.main.getProfile().member_id,
                    // always 2, distributor
                    customer_type_id: 2,
                    country: app.location.getCurrentLocation(),
                    culture: app.main.getCurrentCulture(),
                    slug: enrollmentPackage.slug ? enrollmentPackage.slug : 'default',
                    // since there's no field for starter kits, prepend the kit id
                    item_ids: enrollmentSelected.kits.concat(enrollmentSelected.products),
                    psk_er: enrollmentSelected.e2.step2 ? true : false,
                    monthly_item_ids: enrollmentSelected.monthly,
                    site_path: app.main.getProfile().site_path || app.main.getProfile().username,
                    profile_image: app.main.getProfile().profile_image,
                    sponsor_name: app.main.getProfile().display_name,
                    // opposite of my var
                    hide_breadcrumb: !stepNavEnabled
                },

                header = {
                    name: 'X-XSRF-TOKEN',
                    value: token
                };

            // for v1, set to true if any monthly products were selected, v2 use the option
            if (app.main.getSettings().v2_enrollment_enabled) {
                if (ceoEnabled) {
                    // CEO has the option to opt-in
                    data.enroll_er = monthlyConfirmed;

                } else {
                    data.enroll_er = enrollmentSelected.e2.step1 ? true : false;
                }

            } else {
                data.enroll_er = enrollmentSelected.monthly.length ? true : false;
            }


            // for CEO, combine all products and add special sku if they've opted out of er
            if (ceoEnabled) {
                if (data.enroll_er == false) {
                    var newItems = data.item_ids.concat(data.monthly_item_ids);
                    data.item_ids = newItems;
                    data.monthly_item_ids = [];
                }
                // always add the special item_id
                data.item_ids.push(ceoItemID);
            }

            // special case for regions where starter kit may be part of monthly er
            if (kitsMonthly) {
                data.item_ids = enrollmentSelected.products;
                data.monthly_item_ids = enrollmentSelected.kits.concat(enrollmentSelected.monthly);
            }

            // add canada product guide if neccessary
            if (enrollmentSelected.include_guide) {
                data.item_ids.push(productGuideID);
            }

            var endPoint = enrollmentPackage.default ? 'enrollment' : 'targeted-enrollment';

            if (!token) {
                app.message.error('Missing XSRF token');
                app.page.hideLoader();
                // return;
            }

            if (ceoEnabled) {
                endPoint = 'order-enrollment';
            }

            self.getResponse({
                url: servicesURL[mode] + endPoint,
                method: 'POST',
                data: data

            }, function(response, xhr) {
                // redirect to enrollment url
                try {
                    if (app.main.getSettings().queueit_enabled) {
                        // redirect to yl redirect page
                        var page = ylURL[mode] +'myyl/?redirect=';
                        window.location.replace(page + encodeURIComponent(response.ce_uri));

                    } else {
                        window.location.replace(response.ce_uri);
                    }
                } catch(e) {
                    app.message.error('CE redirect failed.');
                }

            }, function(jqXHR) {
                // error
                app.message.error('Error getting enrollment redirect: ');
            }, 'json', header);
        },

        /**
         * Render and init the info page
         */
        renderInfo: function () {
            setTimeout(function() {
                var currentMode = app.skava.getShoppingMode(app.skava.BWM_SHOPPING_MODE);
                if (currentMode !== app.skava.BWM_SHOPPING_MODE) {
                    window.location.href = '#';
                    window.location.reload();
                    return;
                }

                pageData.brandPartner = enrollmentPackage.brandPartner;

                if (pageData.monthly && pageData.monthly.length > 0) {
                    pageData.hasSubscriptionProducts = true;
                }

                app.skava.renderForm('#enrollment', pageData);

                if ($('#package-welcome')) {
                    // Needed UI fix for checkout account page
                    $('#package-welcome').addClass('checkout-account');
                    $('#enrollment').removeClass('no-pad');
                }
            });
        },

        /**
         * Render and init the welcome page
         */
        renderWelcome: function(pageData) {
            if (!enrollmentPackage.welcome) {
                // default welcome letter
                enrollmentPackage.welcome = 0;
            }

            // construct contact form url
            pageData.contact_url = '/contact/'+ pageData.profile.culture +'/'+ pageData.profile.member_id +'/';

            if (location.hostname === 'localhost') {
                pageData.contact_url = 'http://localhost:8000/contact/'+ pageData.profile.culture +'/'+ pageData.profile.member_id +'/';
            }

            pageData.welcome = welcomeData.letters[enrollmentPackage.welcome];
            pageData.welcome.index = enrollmentPackage.welcome;

            $('#page').html(app.main.getTemplate('enrollment-'+ currentStep, pageData));

            if (app.pws.isPreview()) {
                self.initPreview();

            } else {
                self.trackEnrollmentPackage();
            }

            // final page - reset
            currentStep = false;
            self.reset();

            $('.social a').on('click', function() {
                app.main.track('CE Welcome', $(this).data('trackingaction'));
            });
        },

        /**
         * Show monthly message on monthly step and on help tip click
         */
        showMonthlyMessage: function(force) {
            if (steps.monthly == true && !force) return;

            steps.monthly = true;

            app.message.alert({
                type: 'info',
                id: 'minpv',
                message: app.main.getTemplate('enrollment-message-pv', {
                    minPV: minPV,
                    ce_monthly_copy: app.main.strReplace(app.main.lang('ce_monthly_copy'), minPV)
                }),
                scroll: true
            });
        },

        /**
         * Show ER Optin message when box is checked, or help-tip is clicked
         */
        showOptinMessage: function() {
            app.message.alert({
                type: 'info',
                id: 'optin-message',
                message: app.main.getTemplate('enrollment-message-er-optin', { message: app.main.lang('ce_er_optin_message') }),
                scroll: true
            });
        },

        /**
         * Add click handlers to details and add buttons
         */
        addProductClickHandlers: function() {
            if (app.main.getSettings().product_card_enabled) {
                app.productcard.enable('enroll');

            } else {

                if (app.main.getSettings().unified_shopping_enabled) {
                    // unified shopping adds directly to cart
                    app.productcard.enable('enroll');

                    // checkout button replaces next button
                    $('.button.checkout').on('click', function(e) {
                        e.preventDefault();
                        app.cart.checkOut();
                    });

                } else {

                    // legacy select toggle
                    $('.btn-add').attr('draggable', 'false').off('click').on('click', function(e) {
                        e.preventDefault();

                        var isKit =  $(this).data('kit'),
                            isMonthly = $(this).data('monthly'),
                            partNumber = $(this).attr('data-part-number');

                        // in case of multiple kits in the carousel, be sure to deselect all others first
                        if (isKit) {
                            $('[data-kit="true"].is-active').not(this).each(function() {
                                // reset kits
                                enrollmentSelected.kits = [];
                                $(this).removeClass('is-active');
                                $(this).find('span').each(function() {
                                    $(this).text(app.main.lang('ce_add'));
                                });
                            });
                        }

                        if ($(this).hasClass('is-active')) {
                            // if a kit is required, this can't be deselected
                            if (isKit && kitsOptional == false) {
                                return;
                            }

                            // remove
                            $(this).removeClass('is-active').find('span').text(app.main.lang('ce_add'));

                            if (isKit) {
                                // make extra checkbox options inactive (some regions won't have these)
                                $('.product.kit .btn-checkbox').addClass('is-disabled').removeClass('is-active');
                                app.main.track('CE Products', 'remove-starterkit', partNumber);

                                if (canadaCE) {
                                    // if starter kit is removed, also remove any special features that may have been checked
                                    self.setExtraFeature('include-guide', false);
                                    self.setExtraFeature('er-optin1', false);
                                }

                                if (ceoEnabled) {
                                    kitDeselected = true;
                                    self.checkMinPV();
                                    self.openCEOBar();

                                    // $('#additional-products').addClass('is-disabled');

                                    // clear any previously chosen products
                                    // if (enrollmentSelected.products.length) {
                                    //     $('.btn-add.is-active').click();
                                    // }

                                    // in case opt-in was checked in step 2, but returned to deselect kit on step 1
                                    monthlyConfirmed = false;
                                }

                            } else if (isMonthly) {
                                app.main.track('CE Products', 'remove-er-product', partNumber);

                            } else {
                                app.main.track('CE Products', 'remove-product', partNumber);
                            }

                        } else {

                            // add
                            $(this).addClass('is-active').find('span').text(app.main.lang('ce_added'));

                            if (isKit) {
                                // make extra checkbox options active (some regions won't have these)
                                $('.product.kit .btn-checkbox').removeClass('is-disabled');
                                app.main.track('CE Products', 'add-starterkit', partNumber);

                                if (canadaCE) {
                                    // remove any previously chosen monthly items if er has not be opped in
                                    if (!enrollmentSelected.er_optin) {
                                        enrollmentSelected.monthly = [];
                                    }
                                }

                                if (ceoEnabled) {
                                    app.message.clear('ceo-pv-message');
                                    kitDeselected = false;
                                    // $('#additional-products').removeClass('is-disabled');
                                }

                            } else if (isMonthly) {
                                app.main.track('CE Products', 'add-er-product', partNumber);

                            } else {
                                app.main.track('CE Products', 'add-product', partNumber);
                            }
                        }

                        var curStep = currentStep;
                        if (isKit) {
                            curStep = 'kits';
                        }

                        var productType = $(this).parent().attr('data-product-type');
                        self.toggleProduct(parseInt($(this).attr('data-id'), 10), curStep, false, productType);

                        self.checkMinPV();
                    });
                }

                $('.btn-details').off('click').on('click', function(e) {
                    e.preventDefault();
                    var $target = $(this).parent().parent().find('.details');

                    if ($target.hasClass('is-active')) {
                        $target.removeClass('is-active');
                        $(this).text(app.main.lang('label_details'));
                    } else {
                        $target.addClass('is-active');
                        $(this).text(app.main.lang('label_close'));
                    }
                });

                $('.link-product').off('click').on('click', function(e) {
                    e.preventDefault();
                    var product = self.getProductByID($(this).attr('data-part-number'), 'part_number');

                    app.modal.load('enrollment-product-modal', {
                        profile: app.main.getProfile(),
                        product: product
                    });

                    $('#modal a').on('click', app.modal.close);

                    app.main.track('CE Products', $(this).data('trackingaction'), $(this).attr('data-part-number'));
                });

                // special case for products that have variants
                $('.variants').off('change').on('change', function(e) {
                    // pass the variant product_id and product_id of the parent product
                    var parentId = $(this).data('parent'),
                        productType = $(this).parent().parent().attr('data-product-type');

                    self.switchVariant($(this).val(), parentId, null, productType);
                });
            }

            // special case for regions where starter kits have extra options
            $('.product.kit .btn-checkbox').off('click').on('click', function(e) {
                e.preventDefault();
                if ($(this).hasClass('is-disabled')) {
                    return;
                }

                if ($(this).hasClass('is-active')) {
                    $(this).removeClass('is-active');
                    self.setExtraFeature($(this).data('type'), false);

                } else {
                    $(this).addClass('is-active');
                    self.setExtraFeature($(this).data('type'), true);
                }
            });

            // special checkbox on monthly page where er is opt-in
            $('.btn-checkbox.er-optin2').off('click').on('click', function(e) {
                e.preventDefault();

                if ($(this).hasClass('is-disabled')) {
                    return;
                }

                if ($(this).hasClass('is-active')) {
                    $(this).removeClass('is-active');
                    self.setExtraFeature('er-optin1', false);
                    $('.product-list.monthly').addClass('is-disabled');

                } else {
                    $(this).addClass('is-active');
                    self.setExtraFeature('er-optin1', true);
                    $('.product-list.monthly').removeClass('is-disabled');
                    self.showOptinMessage();

                    // toggle starter kit (true = it's a kit) - add kit if it isn't already there
                    if (enrollmentSelected.kits.length < 1) {
                        var product = self.getProductByID(enrollmentPackage.product_ids.kits[0]);
                        if (product) {
                            self.toggleProduct(product.item_id, 'kits');
                        }

                    } else {
                        // refresh totals since we're not adding again
                        self.calcTotals();
                    }
                }
            });

            // special case on monthly page to open modal product window from inside the optin checkbox
            $('.btn-checkbox a').off('click').on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var product = self.getProductByID($(this).attr('data-id'));

                app.modal.load('enrollment-product-modal', {
                    profile: app.main.getProfile(),
                    product: product
                });
            });

            // special help button inside optional er checkbox label
            $('.help-tip.er').off('click').on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                self.showOptinMessage();
            });

            // only enable for non-skava regions that don't use the product card module
            if (!app.main.getSettings().skavaEnabled) {
                // init quantity select
                $('.selected').off().on('click', function() {
                    var pos = $(this).offset(),
                        $parent = $(this).parent(),
                        $select = $('#select-list');

                    if ($parent.hasClass('is-active')) {
                        self.closeSelect();

                    } else {
                        self.closeSelect();
                        $parent.addClass('is-active');
                        $(window).on('resize', self.closeSelect);

                        $select.css({
                            top: Math.round(pos.top) + 37,
                            left: Math.round(pos.left)
                        }).show();

                        $('li:not(.other)', $select).on('click', function() {
                            self.setQty($parent, $(this).text());
                            self.closeSelect();
                        });
                    }

                    $('li.other input', $select)
                        .on('keyup blur', function(e) {
                            var num = $(this).val().replace(/\D/g, '');
                            $(this).val(num);

                            switch (e.keyCode) {
                                // enter/return
                                case 13:
                                    self.setQty($parent, num);
                                    self.closeSelect();
                                break;
                                // esc
                                case 27:
                                    self.closeSelect();
                                break;
                            }
                        })
                        .on('focus', function() {
                           // disable the document mousdown handler so the blur event will take precedence
                           $('body,.carousel').off('mousedown touchstart');
                        })
                        .on('blur', function() {
                            if ($(this).val()) {
                                self.setQty($parent, $(this).val());
                                self.closeSelect();
                            }
                        });

                    // close the select drop-down when anything else is clicked
                    $('body,.carousel').off().on('mousedown touchstart', function(e) {
                        // ignore on the select-list element or quantity field inside it (other)
                        if (e.target.parentElement.id != 'select-list' && e.target.parentElement.className != 'other') {
                            self.closeSelect();
                            $('body,.carousel').off('mousedown touchstart');
                        }
                    });
                });
            }
        },

        /**
         * Close and disable and product quantity select lists
         */
        closeSelect: function() {
            $(window).off('resize', self.closeSelect);
            $('.select').removeClass('is-active');
            $('#select-list li').off('click');
            $('#select-list .other input').val('').off('keyup blur');
            $('#select-list').hide();
        },

        /**
         * Sets the quantity value based on selection or 'other' field entry
         */
        setQty: function($parent, num) {
            num = parseInt(num, 10);

            if (num < 1 || isNaN(num)) {
                return;
            }

            $('.selected', $parent).text(num);
            $('.field-quantity', $parent).val(num);

            // apply chosen quantity to btn-add for use when actually selected
            var $target = $('.btn-add', $parent.parent());
            $target.attr('data-quantity', num);

            var item_id = $target.attr('data-id'),
                productType = $parent.parent().attr('data-product-type');

            productList = enrollmentSelected.products;

            if (productType == 'monthly') {
                productList = enrollmentSelected.monthly;
            }

            // productList must be set before searching for index
            var index = self.getProductIndex(item_id);
            if (index > -1) {
                var item = productList[index];

                if (item && item.quantity) {
                    item.quantity = num;
                }

            } else {
                // console.log('did not find '+ item_id);
            }

            self.saveState();
        },

        /**
         * Handle toggling of extra features for special regions
         */
        setExtraFeature: function(type, bool) {
            switch (type) {
                // CA product guide
                case 'include-guide':
                    enrollmentSelected.include_guide = bool;
                break;

                // enable or disable essential rewards
                case 'er-optin1':
                    kitsMonthly = bool;
                    enrollmentSelected.er_optin = bool;

                    // if false, then clear any previously chosen monthly products
                    if (bool !== true) {
                        enrollmentSelected.monthly = [];

                        if (currentStep == 'monthly' || currentStep =='e2') {
                            $('.btn-add').removeClass('is-active').find('span').text(app.main.lang('ce_add'));
                        }
                    }
                    self.calcTotals();
                break;
            }
            self.saveState();
        },

        /**
         * Search for a product with given ID and return it
         */
        getProductByID: function(id, type) {
            if (!type) {
                type = 'product_id';
            }

            if (typeof id == 'object') {
                id = id[type];
            }

            // add starter kits
            var allProducts = products.concat(kits),
                promoSubfolder = 'kits';

            if (app.main.getSettings().skavaEnabled) {
                // todo: this will probably change
                promoSubfolder = 'kits';
            }

            for (var i=0; i<allProducts.length; i++) {
                if (allProducts[i][type] == id) {
                    if (allProducts[i].enrollment == true || allProducts[i].promo_image_enabled == true) {
                        // custom images for starter kits
                        // strip out any 'D' chars from part number to create this URL
                        allProducts[i].image_new = promoURL[mode] +'img/'+ promoSubfolder +'/'+ allProducts[i].part_number.split('D').join('') +'.jpg';
                    }

                    return allProducts[i];
                }
            }
            return false;
        },

        /**
         * Add a product to the list, or remove it if already in the list
         * id: item_id
         * category: products, monthly, e2 or kits
         * remove: force the product removal
         * quantity: default is 1, currently only used in the 'additional products' bundle step
         */
        toggleProduct: function(id, category, remove, productType, quantity) {
            if (!quantity) {
                quantity = parseInt($('.btn-add[data-id='+ id +']').attr('data-quantity'), 10);

                if (!quantity) {
                    quantity = 1;
                }
            }

            switch (category) {
                case 'products':
                    productList = enrollmentSelected.products;
                break;

                case 'monthly':
                case 'e2':
                    productList = enrollmentSelected.monthly;
                break;

                case 'subscription':
                case 'review':
                    if (productType === 'monthly') {
                        productList = enrollmentSelected.monthly;

                    } else {
                        productList = enrollmentSelected.products;
                    }
                break;

                case 'kits':
                case 'bundle-loyalty':
                    productList = enrollmentSelected.kits;
                break;

                default:
                    throw new Error('Category property is required for toggleProduct().');
            }

            var index = self.getProductIndex(id);

            if (index > -1 || remove === true) {
                // remove it
                productList.splice(index, 1);

            } else {
                // console.log('quantity', quantity);

                // only create an object if quantity > 1, otherwise just store the id as usual
                if (quantity > 1 || category == 'bundle-loyalty') {
                    // todo: need to account for id being an object already
                    var obj = {
                        item_id: id,
                        quantity: quantity
                    };

                    if (category == 'bundle-loyalty') {
                        obj.isSubscription = true;
                    }

                    productList.push(obj);

                } else {
                    productList.push(id);
                }
            }

            switch (category) {
                case 'products':
                    enrollmentSelected.products = productList;
                break;

                case 'monthly':
                case 'e2':
                    enrollmentSelected.monthly = productList;
                break;

                case 'subscription':
                case 'review':
                    if (productType === 'monthly') {
                        enrollmentSelected.monthly = productList;

                    } else {
                        enrollmentSelected.products = productList;
                    }
                break;

                case 'kits':
                case 'bundle-loyalty':
                    enrollmentSelected.kits = productList;
                break;
            }

            if (app.main.getSettings().skavaEnabled) {
                // enable/disable add to cart button
                if (self.checkIfSelectedProducts()) {
                    $('.btn-next').removeClass('is-disabled');

                } else {
                    $('.btn-next').addClass('is-disabled');
                }
            }

            self.calcTotals();
            self.saveState();

            // return false if product removed, true if added - used to ga tracking
            if (index > -1 || remove === true) {
                return false;

            } else {
                return true;
            }
        },

        // make enrollmentSelected available to other modules (like search)
        getEnrollmentSelected: function() {
            return app.main.clone(enrollmentSelected);
        },

        // debugging
        dump: function() {
            console.log('enrollmentPackage', enrollmentPackage);
            console.log('enrollmentSelected', enrollmentSelected);
            console.log('totals', self.calcTotals());
            console.log('pageData', pageData);
        },

        /**
         * For additional products, the id must be added to the enrollmentPackage for proper processing
         */
        addAdditionalProduct: function(item_id, quantity, isSubscription) {
            var packageType = enrollmentPackage.product_ids.products;
            if (isSubscription) {
                packageType = enrollmentPackage.product_ids.monthly;
            }

            // todo: only add if not currently present
            var index = self.getProductIndex(item_id),
                product = self.getProductByID(item_id, 'item_id');

            if (quantity > 1) {
                packageType.push({
                    product_id: product.product_id,
                    item_id: item_id,
                    quantity: quantity
                });

            } else {
                packageType.push(item_id);
            }
        },

        /**
         * Search through the list of selected enrollment items for an item_id and return the position
         * Returns -1 if not found
         * id is either a item_id or an object {item_id: int, quantity: int}
         */
        getProductIndex: function(id, list) {
            var index = -1;

            if (!id) {
                return index;
            }

            // default to the global productList if not provided
            if (!list) {
                list = productList;
            }

            // get index of id in productList if it exists
            for (var i=0; i<list.length; i++) {
                // todo: next line was toggling product add/remove why?
                // if (list[i] == id || list[i].item_id == id || list[i].item_id == id.item_id) {
                if (list[i] == id || list[i].item_id == id) {
                    index = i;
                    break;
                }
            }

            return index;
        },

        /**
         * Check if any products have been selected
         */
        checkIfSelectedProducts: function() {
            var selected = enrollmentSelected.products.concat(enrollmentSelected.kits, enrollmentSelected.monthly);
            return selected.length > 0 ? true : false;
        },

        /**
         * Checks to see if a variant product_id exists in the selected enrollment package so it can be shown as added
         */
        findVariant: function(id, isKit, productType) {
            switch (currentStep) {
                case 'products':
                    productList = enrollmentSelected.products;
                break;

                case 'monthly':
                case 'e2':
                    productList = enrollmentSelected.monthly;
                break;

                case 'subscription':
                    if (productType === 'monthly') {
                        productList = enrollmentSelected.monthly;
                    } else {
                        productList = enrollmentSelected.products;
                    }
                break;
            }

            // special case for kits
            if (isKit === true) {
                productList = enrollmentSelected.kits;
            }

            if (productList.includes(id)) {
                return true;

            } else {
                return false;
            }
        },

        /**
         * When switching a variant from the drop-down, change the image and various IDs. If the product has been added previously
         * Called by the $('.variants').on('change') event in addProductClickHandlers()
         * Use item_id for adding/removing to enrollmentSelected
         */
        switchVariant: function(variant_id, product_id, added, productType) {
            var product = self.getProductByID(variant_id, 'item_id'),
                prevID,
                $target;


            if (productType == 'monthly') {
                $target = $('#monthly-product-'+ product_id);

            } else {
                $target = $('#product-'+ product_id);
            }

            prevID = parseInt($('.btn-add', $target).attr('data-id'), 10);

            if (product) {
                // show/hide out of stock message or select checkbox depending on in_stock
                if (product.in_stock) {
                    $('.btn-add', $target).show();
                    $('.out-of-stock', $target).hide();

                } else {
                    $('.btn-add', $target).hide();
                    $('.out-of-stock', $target).show();
                }

                var bgImage = 'url('+ product.image_url +')';

                if (product.image_new) {
                    // add fallback image
                    bgImage = 'url('+ product.image_new +'), url('+ product.image_url +')';
                }

                $('.img', $target).css({
                   'background-image': bgImage
                });

                // update prices, check tax_inclusive_pricing_enabled to decide which price to show
                $('.prices .wholesale span', $target).text(
                    app.global.currency(
                        app.main.getSettings().tax_inclusive_pricing_enabled ? product.wholesale_price_with_tax : product.wholesale_price
                    )
                );

                if (product.price_after_discount) {
                    $('.prices .discount', $target).text(app.global.currency(product.price_after_discount));
                }

                $('.product-name', $target).html(function() {
                    return product.name + (product.variant ? '<span class="nobr"> - '+ product.variant +'</span>' : '');
                });

                $('.prices .retail span', $target).text(
                    app.global.currency(
                        app.main.getSettings().tax_inclusive_pricing_enabled ? product.retail_price_with_tax : product.retail_price
                    )
                );

                $('.prices .pv span', $target).text(app.global.round(product.distributor_point_value));
                $('[data-id]', $target).attr('data-id', product.item_id);

                // change part number for tracking
                $('[data-part-number]', $target).attr('data-part-number', product.part_number);

                // if already added, change the product_id in the selected products list
                if ($('.btn-add', $target).hasClass('is-active') && !product.enrollment) {
                    self.removeVariant(prevID, false, productType);
                    self.toggleProduct(product.item_id, currentStep, false, productType);
                }

                // special case for kits with variants - when only 1 kit is available (not in the carousel)
                // if kit is required, or is optional but checked then switch it in enrollmentSelected
                if (enrollmentPackage.product_ids.kits.length == 1) {
                    if ((($('.btn-add', $target).hasClass('is-active') && kitsOptional === true) || kitsOptional === false) && product.enrollment === true) {
                        enrollmentSelected.kits = [product.item_id];
                        self.saveState();
                    }
                }

                if (added === true) {
                    // when rendering the page, this will check the added box if the variant was found in the selected product list
                    $('.btn-add', $target).addClass('is-active');
                }

            } else {
                // this means an invalid variant_id or 0 was passed, so remove and uncheck added
                //self.toggleProduct(self.toggleProduct(prevID));
            }
        },

        /**
         * Similar to toggleProduct(), but for products with vairants this will attempt to remove an existing variant before adding the chosen one
         * If it hasn't been added, then this will do nothing
         */
        removeVariant: function(id, isKit, productType) {
            switch (currentStep) {
                case 'products':
                    productList = enrollmentSelected.products;
                break;

                case 'monthly':
                case 'e2':
                    productList = enrollmentSelected.monthly;
                break;

                case 'subscription':
                    if (productType === 'monthly') {
                        productList = enrollmentSelected.monthly;
                    } else {
                        productList = enrollmentSelected.products;
                    }
                break;
            }

            // special case for kits
            if (isKit === true) {
                productList = enrollmentSelected.kits;
            }

            var index = self.getProductIndex(id);

            if (index > -1) {
                productList.splice(index, 1);

            } else {
                console.log('variant id '+ id +' not found');
            }
        },

        openPvErrorModal: function() {
            app.modal.load('enrollment-error-pv', {
                ce_error_pv_copy: app.main.strReplace(app.main.lang('ce_error_pv_copy'), [minPV, totalPV])
            });
            $('#btn-update').one('click', app.modal.close);
            app.main.track('CE', 'error-shown-low-pv');
        },

        openCEOModal: function() {
            app.modal.load('enrollment-ceo-modal', {
                minPV: minPV
            });

            $('#btn-ok').one('click', app.modal.close);
        },

        openCEOBar: function() {
            app.message.alert({
                type: 'info',
                id: 'ceo-pv-message',
                message: app.main.getTemplate('enrollment-ceo-pv', { minPV: minPV })
            });

            $('#link-confirm').on('click', function(e) {
                e.preventDefault();
            });
        },

        /**
         * Check that PV min is met and that monthly purchase is confirmed
         * Also, special case for canadaCE if a kit is selected for monthly subscription (er_optin)
         */
        validateMonthly: function() {
            var pvError = false;

            if (currentStep === 'e2') {
                if (ceoEnabled) {
                    if (kitDeselected && pvProducts < minPVceo) {
                        pvError = true;
                    }

                } else {
                    if (totalPV < minPV) {
                        pvError = true;
                    }
                }
            }

            if (pvError) {
                self.openPvErrorModal();
                return;
            }

            if (currentStep === 'e2' && ceoEnabled && enrollmentSelected.monthly.length && !monthlyConfirmed) {
                self.openCEOModal();
                return;
            }

            if (currentStep != 'e2') {
                if (enrollmentSelected.monthly.length > 0 || (enrollmentSelected.er_optin && enrollmentSelected.kits.length > 0)) {
                    if (totalPV < minPV) {
                        self.openPvErrorModal();
                        return;
                    }

                    if ($('#confirm-monthly').hasClass('is-active') == false) {
                        app.main.track('CE', 'error-shown-confirmation-needed');

                        app.message.alert({
                            type: 'error',
                            id: 'monthly-confirm',
                            message: app.main.getTemplate('enrollment-error-monthly')
                        });

                        $('#link-clear').on('click', function(e) {
                            e.preventDefault();
                            // clear all products
                            enrollmentSelected.monthly = [];

                            // also clear kits and options for canadaCE
                            if (enrollmentSelected.er_optin) {
                                enrollmentSelected.er_optin = false;
                                enrollmentSelected.kits = [];
                                $('.er-optin2').removeClass('is-active');
                            }

                            self.saveState();
                            self.ready();
                        });

                        $('#link-confirm').on('click', function(e) {
                            e.preventDefault();
                            $('#confirm-monthly').addClass('is-active');
                            monthlyConfirmed = true;
                            self.validateMonthly();
                            app.main.track('CE', 'next-confirm-clicked', $(this).text());
                        });
                        return;
                    }
                }
            }

            app.page.loadPage(self.getPath('build/review'));
        },

        /**
         * Validate that chosen language/location in first step matches with the member
         */
        validateCulture: function(val) {
            if ('other' == val) {
                app.main.track('CE', 'change-location', val);
                $('.btn-next').addClass('is-disabled');
                $('#enrollment-location-toggle').html(app.main.lang('toggle_label_other')+ '<i></i>').addClass('other');
                $('#culture-error').html(app.main.strReplace(app.main.lang('ce_culture_error'), app.main.getEnrollURL())).slideDown();
                return false;
            }

            if ('reset' == val) {
                // clear any previously selected items before reloading
                self.reset(true);
            }
        },

        /**
         * Add up prices for montly enrollment products
         * Some totals were removed from the front end, but let's leave the them in place just in case
         */
        calcTotals: function() {
            var i,
                priceKits = 0,
                priceProducts = 0,
                retailProducts = 0,
                priceMonthly = 0,
                retailMonthly = 0,
                pvKits = 0,
                pvMonthly = 0,
                grandTotal = 0,
                quantity = 1,
                product,
                hideLabel = false; // hide USD currency label

            totalPV = 0;
            pvProducts = 0;

            // kits
            for (i=0; i<enrollmentSelected.kits.length; i++) {
                product = self.getProductByID(enrollmentSelected.kits[i], 'item_id');

                if (product) {
                    if (!product.distributor_point_value) {
                        product.distributor_point_value = 0;
                    }
                    priceKits += self.getPrice(product);
                    pvKits += product.distributor_point_value;
                }
            }

            // products
            for (i=0; i<enrollmentSelected.products.length; i++) {
                product = self.getProductByID(enrollmentSelected.products[i], 'item_id');

                quantity = 1;

                if (enrollmentSelected.products[i].quantity) {
                    quantity = enrollmentSelected.products[i].quantity;
                }

                // if product promo from the cart is present then price already includes quantity, so no multiplication is needed
                if (product.promo) {
                    priceProducts += self.getPrice(product);
                    retailProducts += product.retail_price_with_tax;
                    pvProducts += product.distributor_point_value;

                } else {
                    priceProducts += self.getPrice(product) * quantity;
                    retailProducts += product.retail_price_with_tax * quantity;
                    pvProducts += product.distributor_point_value * quantity;
                }
            }

            // subscription products (monthly)
            for (i=0; i<enrollmentSelected.monthly.length; i++) {
                product = self.getProductByID(enrollmentSelected.monthly[i], 'item_id');

                if (product) {
                    if (!product.distributor_point_value) {
                        product.distributor_point_value = 0;
                    }

                    quantity = 1;

                    if (enrollmentSelected.monthly[i].quantity) {
                        quantity = enrollmentSelected.monthly[i].quantity;
                    }

                    // if product promo from the cart is present then price already includes quantity, so no multiplication is needed
                    if (product.promo) {
                        priceMonthly += self.getPrice(product);
                        retailMonthly += product.retail_price_with_tax;
                        pvMonthly += product.distributor_point_value;
                        totalPV += parseInt(product.distributor_point_value, 10);

                    } else {
                        priceMonthly += self.getPrice(product) * quantity;
                        retailMonthly += product.retail_price_with_tax * quantity;
                        pvMonthly += product.distributor_point_value * quantity;
                        totalPV += parseInt(product.distributor_point_value * quantity, 10);
                    }
                }
            }

            pvKits = pvKits / 100;
            pvProducts = pvProducts / 100;
            pvMonthly = pvMonthly / 100;
            totalPV = totalPV / 100;
            grandTotal = priceKits + priceProducts;

            // only if PSK isn't used as the 1st month's order
            if (!kitDeselected && !enrollmentSelected.e2.step2) {
                grandTotal += priceMonthly;
            }

            // some regions include kit pv as part of total
            if (kitsMonthly) {
                priceMonthly += priceKits;
                totalPV += pvKits;
            }

            if (app.main.getSettings().skavaEnabled) {
                // also include pvProducts;
                totalPV += pvKits;
                totalPV += pvProducts;
                hideLabel = true;
            }

            var discountProducts = accounting.toFixed(retailProducts * discount, 2),
                discountMonthly = accounting.toFixed(retailMonthly * discount, 2);

            $('.price.kits').text(app.global.currency(priceKits, false, hideLabel));
            $('.price.products').text(app.global.currency(priceProducts, false, hideLabel));
            $('.price.monthly').text(app.global.currency(priceMonthly, false, hideLabel));
            $('.savings-products').text(app.global.currency(discountProducts, false, hideLabel));
            $('.savings-monthly').text(app.global.currency(discountMonthly, false, hideLabel));
            $('#total-pv span, .price.pv-total').text(totalPV);

            // never show NaN in case skava isn't available
            if (isNaN(totalPV)) {
                $('.ledger.total.pv').hide();
            }

            if (app.main.getSettings().skavaEnabled) {
                var level = self.getPVRewardLevel();
                $('#total-pv .reward li').removeClass();

                for (i=1; i<=level; i++) {
                    $('#total-pv li:nth-child('+ i +')').addClass('is-active');
                }

                $('#total-pv li:nth-child('+ level +')').addClass('current');

                // special case for reward1 which is only valid for subscription products
                if (self.subscriptionsSelected()) {
                    $('#pv-level1').addClass('is-active');

                } else {
                    $('#pv-level1').removeClass('is-active');
                }

                $('#pv-toggle').off('click').on('click', function(e) {
                    e.preventDefault();
                    $(this).toggleClass('is-active');
                    $('#total-pv').toggleClass('show-all');
                });
            }

            $('.price.grand-total').text(app.global.currency(grandTotal, false, hideLabel));
            $('.kits-monthly .kits-pv').text(pvKits);

            // don't calc PV on products step
            if (currentStep != 'products') {
                if (totalPV >= minPV) {
                    $('#total-pv').addClass('is-valid');

                } else {
                    $('#total-pv').removeClass('is-valid');
                }

                if (totalPV > 0) {
                    if (app.main.getSettings().skavaEnabled == false) {
                        $('#total-pv').addClass('is-active');
                    }
                    if (currentStep != 'e2' || ceoEnabled == true) {
                        $('.confirm').show();
                    }

                } else {
                    if (app.main.getSettings().skavaEnabled == false) {
                        $('#total-pv').removeClass('is-active');
                    }
                    $('.confirm').hide();

                    // if (ceoEnabled == true && enrollmentSelected.kits.length > 0) {
                    //     $('.confirm').show();
                    // }
                }
            }

            // special pv ticker only for ceo
            if (ceoEnabled && kitDeselected && currentStep === 'products') {
                $('#total-pv span, .price.pv-total').text(pvProducts);
                $('#total-pv').addClass('is-active');

                if (pvProducts >= minPVceo) {
                    $('#total-pv').addClass('is-valid');

                } else {
                    $('#total-pv').removeClass('is-valid');
                }
            }

            if (!kitDeselected && currentStep === 'products') {
                $('#total-pv').removeClass('is-active');
            }

            var totals = {
                priceKits: priceKits,
                priceProducts: priceProducts,
                priceMonthly: priceMonthly,
                totalPV: totalPV,
                grandTotal: grandTotal
            };

            // for skava review accordion page
            return totals;
        },

        /**
         * Special pv ticker for the unified shopping flow
         */
        calcPV: function(cartItems) {
            if (!app.main.getSettings().unified_shopping_enabled) {
                return;
            }

            var totalPV = 0;

            if (cartItems && cartItems.length) {
                cartItems.forEach(function(item) {
                    totalPV += (item.retail_point_value * item.quantity);
                });
            }

            totalPV = app.global.round(totalPV);

            $('#total-pv span').text(totalPV);
            $('#total-pv .unified').text(app.main.strReplace(app.main.lang('unified_pv_copy'), minPV));

            if (totalPV >= minPV) {
                $('#total-pv').addClass('is-valid');

            } else {
                $('#total-pv').removeClass('is-valid');
            }

            if (totalPV > 0) {
                $('#total-pv').addClass('is-active');

            } else {
                $('#total-pv').removeClass('is-active');
                $('#total-pv .unified').empty();
            }
        },

        // return appropriate price if skava is enabled
        getPrice: function(product) {
            if (!product) {
                return 0;
            }

            if (app.main.getSettings().skavaEnabled) {
                // check for discounts
                if (product.promo) {
                    return product.promo.priceAfterDiscount;
                }

                return product.price;

            } else {
                return product.wholesale_price_with_tax;
            }
        },

        getPVRewardKey: function() {
            var pvKey = '';

            if (totalPV >= 100) {
                pvKey = 'ce_pv_reward3';

            } else if (totalPV >= 50) {
                pvKey = 'ce_pv_reward2';

            } else if (totalPV > 0) {
                pvKey = 'ce_pv_reward1';
            }

            return pvKey;
        },

        getPVRewardLevel: function() {
            var level = 0;

            if (totalPV >= 100) {
                level = 3;

            } else if (totalPV >= 50) {
                level = 2;

            } else if (totalPV > 0) {
                level = 1;
            }

            return level;
        },

        // check if any selected items are subscriptions (loyalty orders)
        subscriptionsSelected: function() {
            if (enrollmentSelected.monthly.length > 0) {
                return true;
            }

            if (enrollmentSelected.kits.length > 0) {
                for (var i=0; i < enrollmentSelected.kits.length; i++) {
                    if ( enrollmentSelected.kits[i].isSubscription === true) {
                        return true;
                        break;
                    }
                }
            }

            return false;
        },

        initPreview: function() {
            $('body').addClass('preview');

            $('a').on('click', function(e) {
                e.preventDefault();
            });

            $('.btn-ce-edit').on('click', function() {
                app.pws.postMessage($(this).data('message'));
            });
        },

        /**
         * Save the profile packet to a cookie for future use
         */
        saveState: function() {
            // inject the current member_id with each cookie save
            enrollmentSelected.memberID = app.main.getProfile().member_id;

            if (enrollmentSelected.slug) {
                enrollmentSelected.slug = encodeURIComponent(decodeURIComponent(enrollmentSelected.slug));
            }

            // short expiration - 1hr
            app.cookie.set(JSON.stringify(enrollmentSelected), cookieName, 1);
        },

        /**
         * Connect to the services api and return the response
         */
        getResponse: function(obj, callback, errorcallback, dataType, header) {
            $.ajax({
                url: obj.url,
                method: obj.method,
                contentType: 'application/json; charset=utf-8',
                cache: false,
                dataType: dataType ? dataType : 'json',
                data: JSON.stringify(obj.data),
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                beforeSend: function(xhr) {
                    if (header) {
                        xhr.setRequestHeader(header.name, header.value);
                    }
                },
                success: function(response, status, xhr) {
                    if (typeof callback == 'function') callback(response, xhr);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    if (typeof errorcallback == 'function') errorcallback(jqXHR);
                }
            });
        },

        /**
         * Used in location chooser to decide whether or not the cart warning copy should be displayed
         */
        hasItems: function() {
            return enrollmentSelected.products.length + enrollmentSelected.monthly.length > 0;
        },

        /**
         * Used in the oauth redirect process to avoid jumping back to the review page on successful redirect
         */
        setAlreadySelected: function(bool) {
            alreadySelected = bool;
        },

        syncBWMCart: function (cb, errorCb, isFinalReview) {
            if (enrollmentPackage.preselected) {
                // disable nav
                app.main.toggleNavigation();

                if (!alreadySelected) {
                    alreadySelected = true;
                    console.log('------ This is a preselected cart package');
                    self.selectAllProducts(true);
                    self.saveState();
                    app.page.loadPage(self.getPath('build/review'), true);

                    // only return on subscription step, otherwise continue
                    if (currentStep == 'subscription') {
                        return;
                    }
                }

            } else {
                // enable nav
                app.main.toggleNavigation(true);
            }

            var sync = function (cartItems) {
                var productsInCart = {
                    monthly: {},
                    kits: {},
                    products: {}
                };

                var itemsToDelete = [];

                // loop through skava cart and make sure to toggle on items locally or delete to match
                for (var i = 0; i < cartItems.length; i++) {
                    var sku = cartItems[i].skus[0];
                    var isGift = cartItems[i].isGift;
                    var isSubscription = cartItems[i].isSubscription;
                    var productId = parseInt(sku.productId);
                    var skuId = parseInt(sku.skuId);
                    var cartProduct = self.getProductByID(productId, 'product_id');
                    var category = 'products';
                    var isStarterKit = cartProduct.starter_kit;

                    // isStarterKit or any product in the kits array
                    if (isStarterKit || self.getProductIndex(cartProduct.item_id, enrollmentSelected.kits) > -1) {
                        category = 'kits';
                    }

                    // isSubscription but not in kits
                    if (isSubscription && self.getProductIndex(cartProduct.item_id, enrollmentSelected.kits) < 0) {
                        category = 'monthly';
                    }

                    if (!isGift) {
                        productsInCart[category][cartProduct.item_id] = cartProduct;

                    } else {
                        // console.log('ignoring gift:');
                        // console.log(cartProduct);
                    }

                    // var matchFound = false;

                    // for (var x = 0; x < enrollmentSelected[category].length; x++) {
                    //     if (enrollmentSelected[category][x] === cartProduct.item_id) {
                    //         matchFound = true;
                    //         break;

                    //     } else if (cartProduct.variants) {
                    //         for (var z = 0; z < cartProduct.variants.length; z++) {
                    //             if (enrollmentSelected[category][x] === cartProduct.variants[z].item_id) {
                    //                 matchFound = true;
                    //                 break;
                    //             }
                    //         }
                    //     }
                    // }

                    // // item is not added, so remove it from the cart
                    // if (!matchFound) {
                    //     // don't try to delete any gift items that were inserted by the Skava side
                    //     if (!cartItems[i].isGift) {
                    //         console.log('Deleting itemId: '+ cartItems[i].itemId);
                    //         itemsToDelete.push({
                    //             productId: productId,
                    //             itemId: cartItems[i].itemId,
                    //             category: category
                    //         });
                    //     }
                    // }
                }

                var finishSync = function () {
                    // loop through local items and add to cart if missing in skava
                    var categories = ['kits', 'monthly', 'products'];

                    var productsToAdd = [];

                    for (var x = 0; x < categories.length; x++) {
                        var category = categories[x];

                        for (var i = 0; i < enrollmentSelected[category].length; i++) {
                            // if (category === 'kits' || category === 'monthly') {
                            //     continue;
                            // }

                            var itemId = enrollmentSelected[category][i];
                            var product = self.getProductByID(itemId, 'item_id');

                            if (!product) {
                                // Todo: temporary fix, product seems to be missing sometimes
                                console.log('Missing product.item_id '+ itemId);
                                continue;
                            }

                            var productAlreadyInCart = false;
                            // console.log(productsInCart[category][product.item_id]);

                            if (productsInCart[category][product.item_id]) {
                                productAlreadyInCart = true;
                                console.log('Already in cart: '+ product.name);

                            } else if (product.variants) {
                                for (var z = 0; z < product.variants.length; z++) {
                                    // console.log('variant', productsInCart[category][product.variants[z].item_id]);
                                    if (productsInCart[category][product.variants[z].item_id]) {
                                        productAlreadyInCart = true;
                                        break;
                                    }
                                }
                            }

                            if (!productAlreadyInCart) {
                                // console.log('not already in cart', product.name);
                                var quantity = product.quantity;

                                if (!quantity) {
                                    quantity = 1;
                                }

                                var addProduct = {
                                    quantity: quantity,
                                    skus: [
                                        {
                                            skuId: product.sku_id,
                                            productId: product.product_id.toString(),
                                            type: "DEFAULT"
                                        }
                                    ],
                                    properties: {},
                                    isSubscription: false
                                };

                                if (category === 'monthly' || itemId.isSubscription === true) {
                                    addProduct.isSubscription = true;
                                    addProduct.subscription = {
                                        frequencyPeriod: 1,
                                        frequencyType: 'MONTHS'
                                    };
                                }

                                productsToAdd.push(addProduct);
                            }
                        }
                    }

                    if (productsToAdd.length === 0) {
                        if (cb) {
                            return cb();
                        }

                    } else {
                        app.skava.sendRequest({
                            url: '/cart/',
                            method: 'POST',
                            data: JSON.stringify(productsToAdd)
                        },
                        function() {
                            // now tell skava to get cart after adding products
                            app.skava.getCart(cb);
                            // cb();
                        }, 

                        function(err) {
                            if (err.responseText) {
                                var response = JSON.parse(err.responseText),
                                    message = '';

                                if (response.message) {
                                    message = response.message;
                                }

                                if (response.errorMessage) {
                                    message = response.errorMessage;
                                }

                                console.log('Failed to add to cart: '+ message);
                            }

                            errorCb();
                        });
                    }
                };

                var numProcessed = 0;
                var numFailed = 0;
                var errors = {};
                for (var x = 0; x < itemsToDelete.length; x++) {
                    if (isFinalReview) {
                        // when confirming the order, we need to local to reflect what's in skava to ensure the user gets what they expect
                        var product = self.getProductByID(itemsToDelete[x].productId, 'product_id');
                        self.toggleProduct(product.item_id, itemsToDelete[x].category);

                    } else {
                        app.skava.sendRequest({
                            url: '/cart/' + itemsToDelete[x].itemId + '/',
                            method: 'DELETE'
                            }, function () {
                                numProcessed++;
                                if (numProcessed === itemsToDelete.length) {
                                    if (numFailed === 0) {
                                        finishSync();
                                    } else {
                                        errorCb(errors.err1, errors.err2, errors.err3);
                                    }
                                }

                            }, function(err1, err2, err3) {
                                numFailed++;
                                numProcessed++;
                                if (numProcessed === itemsToDelete.length) {
                                    errorCb(err1, err2, err3);
                                } else {
                                    errors.err1 = err1;
                                    errors.err2 = err2;
                                    errors.err3 = err3;
                                }
                        });
                    }
                }

                // if deleting items, processing will proceed when the deletes are finished
                if (isFinalReview || itemsToDelete.length === 0) {
                    finishSync();
                }
            };

            // app.skava.sendRequest({
            app.skava.getCart(function(response, status, xhr) {
                var cartList = [];

                if (response) {
                    cartList = response.items;
                }

                if (!cartList) {
                    cartList = [];
                }

                sync(cartList);

            }, function (err) {

                try {
                    if (err.responseText) {
                        var message = JSON.parse(err.responseText);
                    }

                } catch(error) {
                    // probably invalid json, server 500 error
                    err = { status: 500 };
                }

                switch (err.status) {
                    // Incorrect authentication credentials.
                    case 403:
                        app.skava.clearSessionId();
                        app.skava.setUpSession(
                            function() {
                                // console.log('new session');
                                // try again
                                self.syncBWMCart(cb, errorCb, isFinalReview);
                            },

                            function(err) {
                                //
                                // console.log('new session fail');
                            });
                        // cb();
                    break;

                    case 500:
                        console.log('server error 500');
                    break;
                }

                if (err && err.status === 400 || err.status === 500) {
                    // empty cart, proceed
                    sync([]);

                } else {
                    errorCb(err);
                }
            });
        }
    };

    return self;
}());
